
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5ULc3", function(module, exports) {

$parcel$export(module.exports, "formatDateForPost", () => $44e6ca573d8ae9e2$export$5b17cf59e0d92666);
function $44e6ca573d8ae9e2$export$5b17cf59e0d92666(date) {
    const now = new Date();
    const diffMs = now - date;
    const diffMinutes = Math.floor(diffMs / 60000);
    if (diffMinutes < 1) return "just now";
    if (diffMinutes === 1) return "1 minute ago";
    if (diffMinutes < 60) return `${diffMinutes} minutes ago`;
    const diffHours = Math.floor(diffMinutes / 60);
    if (diffHours === 1) return `1 hour ago`;
    if (diffHours < 24) return `${diffHours} hours ago`;
    const diffDays = Math.floor(diffHours / 24);
    if (diffDays === 1) return `1 day ago`;
    if (diffDays < 30.416667) return `${diffDays} days ago`;
    const diffMonths = Math.floor(diffDays / 30.416667);
    if (diffMonths === 1) return `1 month ago`;
    if (diffMonths < 12) return `${diffMonths} months ago`;
    const reformedDate = date;
    const options = {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
    };
    return Intl.DateTimeFormat('en-US', options).format(reformedDate);
}

});

parcelRegister("czNeG", function(module, exports) {

$parcel$export(module.exports, "createPlus18Screen", () => $927ef21d8cf1769d$export$4f647ca3f6fcffe7);

var $iqZMU = parcelRequire("iqZMU");

var $81Clf = parcelRequire("81Clf");
function $927ef21d8cf1769d$export$4f647ca3f6fcffe7(elementToBlur = null) {
    const black18Screen = (0, $iqZMU.createElement)('div', null, [
        'plus-18-screen'
    ]);
    const black18ScreenInnerGroup = (0, $iqZMU.createElement)('div', null, [
        'plus-18-screen-inner-group'
    ]);
    const black18ScreenExplanation = (0, $iqZMU.createElement)('p', null, [
        'plus-18-screen-explanation'
    ]);
    black18ScreenExplanation.innerText = "To view this content, you need to be 18 years old or above.";
    const black18ScreenQuestion = (0, $iqZMU.createElement)('p', null, [
        'plus-18-screen-question'
    ]);
    black18ScreenQuestion.innerText = "Are you over 18?";
    const black18ScreenButtonGroup = (0, $iqZMU.createElement)('div', null, [
        'plus-18-screen-button-group'
    ]);
    const black18ScreenButton = (0, $iqZMU.createElement)('button', null, [
        'plus-18-screen-button'
    ]);
    black18ScreenButton.addEventListener('click', ()=>{
        if (elementToBlur !== null && elementToBlur !== undefined) {
            elementToBlur.classList.remove('blurred');
            black18Screen.remove();
        }
    });
    (0, $81Clf.makeNewButton)(black18ScreenButton, 'gray', 'black', 'Yes, I am.', 'lighten');
    black18ScreenButtonGroup.append(black18ScreenButton);
    black18ScreenInnerGroup.append(black18ScreenExplanation);
    black18ScreenInnerGroup.append(black18ScreenQuestion);
    black18ScreenInnerGroup.append(black18ScreenButtonGroup);
    black18Screen.append(black18ScreenInnerGroup);
    black18Screen.black18ScreenInnerGroup = black18ScreenInnerGroup;
    black18Screen.black18ScreenExplanation = black18ScreenExplanation;
    black18Screen.black18ScreenQuestion = black18ScreenQuestion;
    black18Screen.black18ScreenButton = black18ScreenButton;
    if (elementToBlur !== null && elementToBlur !== undefined) elementToBlur.classList.add('blurred');
    black18Screen.createGoBackButton = ()=>$927ef21d8cf1769d$var$createGoBackButton(black18Screen);
    black18Screen.create18WarningIconInBeginning = ()=>$927ef21d8cf1769d$var$create18WarningIconInBeginning(black18Screen);
    black18Screen.create18WarningIconInEnd = ()=>$927ef21d8cf1769d$var$create18WarningIconInEnd(black18Screen);
    return black18Screen;
}
function $927ef21d8cf1769d$var$createGoBackButton(black18Screen) {
    const black18ScreenInnerGroup = black18Screen.black18ScreenInnerGroup;
    const black18ScreenButton = black18Screen.black18ScreenButton;
    const buttonRemoved = !black18ScreenInnerGroup.contains(black18ScreenButton);
    const buttonGoBack = (0, $iqZMU.createElement)('button', null, [
        'plus-18-screen-go-back-button'
    ]);
    (0, $81Clf.makeNewButton)(buttonGoBack, 'gray', 'black', 'No, take me back.', 'lighten');
    buttonGoBack.addEventListener('click', ()=>{
        if (document.referrer !== '') history.back();
        else window.location.href = "/";
    });
    if (buttonRemoved) black18ScreenInnerGroup.append(buttonGoBack);
    else black18ScreenButton.insertAdjacentElement('beforebegin', buttonGoBack);
}
function $927ef21d8cf1769d$var$create18WarningIcon() {
    const warning18Icon = (0, $iqZMU.createElement)('div', null, [
        'plus-18-screen-icon'
    ]);
    const warning18Img = (0, $iqZMU.createElement)('img', null, null);
    warning18Img.src = "/images/icons/plus_18.png";
    warning18Icon.imageElement = warning18Img;
    warning18Icon.append(warning18Img);
    return warning18Icon;
}
function $927ef21d8cf1769d$var$create18WarningIconInBeginning(black18Screen) {
    const warning18Icon = $927ef21d8cf1769d$var$create18WarningIcon();
    black18Screen.black18ScreenInnerGroup.insertAdjacentElement('afterbegin', warning18Icon);
    $927ef21d8cf1769d$var$addShapeFunctions(black18Screen, warning18Icon);
}
function $927ef21d8cf1769d$var$create18WarningIconInEnd(black18Screen) {
    const warning18Icon = $927ef21d8cf1769d$var$create18WarningIcon();
    black18Screen.black18ScreenInnerGroup.insertAdjacentElement('beforeend', warning18Icon);
    $927ef21d8cf1769d$var$addShapeFunctions(black18Screen, warning18Icon);
}
//----------------Shape functions-------------------\\
function $927ef21d8cf1769d$var$addShapeFunctions(black18Screen, icon) {
    black18Screen.makeIconRound = ()=>$927ef21d8cf1769d$var$makeIconRound(icon);
    black18Screen.makeIconRoundedSquare = ()=>$927ef21d8cf1769d$var$makeIconRoundedSquare(icon);
    black18Screen.makeIconRhombus = ()=>$927ef21d8cf1769d$var$makeIconRhombus(icon);
}
function $927ef21d8cf1769d$var$makeIconRound(icon) {
    icon.style.aspectRatio = "1 / 1";
    icon.style.borderRadius = "50%";
    icon.imageElement.style.width = "110%";
}
function $927ef21d8cf1769d$var$makeIconRoundedSquare(icon) {
    icon.style.aspectRatio = "1 / 1";
    icon.style.borderRadius = "15%";
}
function $927ef21d8cf1769d$var$makeIconRhombus(icon) {
    icon.style.aspectRatio = "1 / 1";
    icon.style.transform = "rotate(45deg)";
    icon.imageElement.style.transform = "rotate(-45deg)";
    icon.imageElement.style.width = "140%";
}

});

parcelRegister("eOEAK", function(module, exports) {

$parcel$export(module.exports, "createExploreMini", () => $ac9538e28536dcab$export$ff1db843066cc72b);
parcelRequire("5ZiIO");

var $iqZMU = parcelRequire("iqZMU");

var $25dWo = parcelRequire("25dWo");

var $c2VNi = parcelRequire("c2VNi");

var $h97NM = parcelRequire("h97NM");

var $lKhJ2 = parcelRequire("lKhJ2");
let $ac9538e28536dcab$var$globalMouseMoveEventsAdded = false;
const $ac9538e28536dcab$var$buildFunctionsDictionaryPrototype = {
    onRevealMore: null
};
function $ac9538e28536dcab$export$ff1db843066cc72b(branchInfo, addBuildFunctionsDictionary = null) {
    const exploreMiniFieldWrapper = (0, $iqZMU.createElement)('div', null, [
        'explore-mini-field-wrapper'
    ]);
    const exploreMiniField = (0, $iqZMU.createElement)('div', null, [
        'explore-mini-field',
        'explore-general-field'
    ]);
    console.log("addBuildFunctionsDictionary ", addBuildFunctionsDictionary);
    const buildFunctionsDictionary = {};
    const sharedRevealParams = {};
    buildFunctionsDictionary.beforeRevealMore = (parentId)=>$ac9538e28536dcab$var$beforeRevealMore(sharedRevealParams, exploreMiniField, parentId);
    buildFunctionsDictionary.onRevealMore = (parentId, newBranches, newBranchesDictionary)=>$ac9538e28536dcab$var$onRevealMore(sharedRevealParams, exploreMiniField, parentId, newBranchesDictionary);
    if (addBuildFunctionsDictionary !== null) {
        if (addBuildFunctionsDictionary.onRevealMore !== null && addBuildFunctionsDictionary.onRevealMore instanceof Function) buildFunctionsDictionary.onRevealMore = (parentId, newBranches, newBranchesDictionary)=>{
            $ac9538e28536dcab$var$onRevealMore(sharedRevealParams, exploreMiniField, parentId, newBranchesDictionary);
            addBuildFunctionsDictionary.onRevealMore(exploreMiniField, newBranches);
        };
    }
    const branchAndLineage = (0, $25dWo.createBranchPreview)(branchInfo, null, buildFunctionsDictionary);
    exploreMiniField.exploreBranchesDictionary = branchAndLineage.exploreBranchesDictionary;
    exploreMiniField.append(branchAndLineage);
    exploreMiniFieldWrapper.append(exploreMiniField);
    const body = document.querySelector('body');
    if ($ac9538e28536dcab$var$globalMouseMoveEventsAdded === false) {
        body.addEventListener('mousemove', (e)=>(0, $c2VNi.mouseMoveDragExplore)(e));
        body.addEventListener('mouseup', (e)=>(0, $c2VNi.mouseUpDragExplore)(e));
        $ac9538e28536dcab$var$globalMouseMoveEventsAdded = true;
    }
    exploreMiniField.addEventListener('mousedown', (e)=>(0, $c2VNi.mouseDownDragExplore)(e));
    exploreMiniFieldWrapper.exploreMiniField = exploreMiniField;
    exploreMiniFieldWrapper.exploreField = exploreMiniField;
    exploreMiniField.exploreMiniFieldWrapper = exploreMiniFieldWrapper;
    exploreMiniField.exploreFieldWrapper = exploreMiniFieldWrapper;
    const getExploreCoordinatesFunction = ()=>(0, $h97NM.getExploreCoordinates)(exploreMiniFieldWrapper, exploreMiniField);
    exploreMiniFieldWrapper.getExploreCoordinates = getExploreCoordinatesFunction;
    exploreMiniField.getExploreCoordinates = getExploreCoordinatesFunction;
    const moveExploreToCoordinatesFunction = (x, y)=>(0, $h97NM.moveExploreToCoordinates)(exploreMiniFieldWrapper, exploreMiniField, x, y);
    exploreMiniFieldWrapper.moveExploreToCoordinates = moveExploreToCoordinatesFunction;
    exploreMiniField.moveExploreToCoordinates = moveExploreToCoordinatesFunction;
    const moveExploreToFunction = (leftPos, topPos)=>(0, $h97NM.moveExploreFieldTo)(exploreMiniFieldWrapper, exploreMiniField, leftPos, topPos);
    exploreMiniFieldWrapper.moveExploreFieldTo = moveExploreToFunction;
    exploreMiniField.moveExploreFieldTo = moveExploreToFunction;
    const scaleExploreFieldFunction = (scale)=>(0, $h97NM.scaleExploreField)(exploreMiniField, scale);
    exploreMiniFieldWrapper.scaleExploreField = scaleExploreFieldFunction;
    exploreMiniField.scaleExploreField = scaleExploreFieldFunction;
    const scaleExploreFieldByFunction = (scaleChange)=>(0, $h97NM.scaleExploreFieldBy)(exploreMiniField, scaleChange);
    exploreMiniFieldWrapper.scaleExploreFieldBy = scaleExploreFieldByFunction;
    exploreMiniField.scaleExploreFieldBy = scaleExploreFieldByFunction;
    exploreMiniFieldWrapper.getMouseCoordinatesInField = (event)=>$ac9538e28536dcab$var$calculateMouseOffsetToParentElement(event, exploreMiniField);
    exploreMiniField.getMouseCoordinatesInField = (event)=>$ac9538e28536dcab$var$calculateMouseOffsetToParentElement(event, exploreMiniField);
    /*
    exploreMiniField.addEventListener('wheel', (event) => {
        event.preventDefault();

        let zoomChange = 1.1**(-event.deltaY/50);
        
        const oldScale = exploreMiniField.zoomScale;
        const newScale = zoomChange*oldScale;
        const minZoomValue = exploreMiniField.minZoomValue;
        const maxZoomValue = exploreMiniField.maxZoomValue;

        if(newScale > maxZoomValue) {
            zoomChange = maxZoomValue/oldScale;
        } else if(newScale < minZoomValue) {
            zoomChange = minZoomValue/oldScale;
        }

        const mouseCoordinates = exploreMiniField.getMouseCoordinatesInField(event);

        const oldCoordinates = exploreMiniField.getExploreCoordinates();
        

        const newX = oldCoordinates.x + (oldCoordinates.x-mouseCoordinates.x)*(1-zoomChange);
        const newY = oldCoordinates.y + (oldCoordinates.y-mouseCoordinates.y)*(1-zoomChange);

        exploreMiniField.scaleExploreFieldBy(zoomChange);
        exploreMiniField.moveExploreToCoordinates(newX, newY);
    });
*/ exploreMiniField.addEventListener('wheel', (event)=>{
        event.preventDefault();
        let zoomChange = 1.1 ** (-event.deltaY / 50);
        const oldScale = exploreMiniField.zoomScale;
        const newScale = zoomChange * oldScale;
        const minZoomValue = exploreMiniField.minZoomValue;
        const maxZoomValue = exploreMiniField.maxZoomValue;
        if (newScale > maxZoomValue) zoomChange = maxZoomValue / oldScale;
        else if (newScale < minZoomValue) zoomChange = minZoomValue / oldScale;
        const mouseCoordinates = exploreMiniField.getMouseCoordinatesInField(event);
        const oldLeft = exploreMiniField.leftPos;
        const oldTop = exploreMiniField.topPos;
        const newLeft = oldLeft - (mouseCoordinates.x - exploreMiniField.offsetWidth / 2) * (1 - zoomChange) * oldScale;
        const newTop = oldTop - (mouseCoordinates.y - exploreMiniField.offsetHeight / 2) * (1 - zoomChange) * oldScale;
        exploreMiniField.scaleExploreFieldBy(zoomChange);
        exploreMiniField.moveExploreFieldTo(newLeft, newTop);
    });
    const centerExploreFieldAroundTheBranchFunction = (branchId)=>(0, $h97NM.centerExploreFieldAroundTheBranch)(exploreMiniFieldWrapper, branchId);
    exploreMiniFieldWrapper.centerExploreFieldAroundTheBranch = centerExploreFieldAroundTheBranchFunction;
    exploreMiniField.centerExploreFieldAroundTheBranch = centerExploreFieldAroundTheBranchFunction;
    const goToBranchFunction = (branchId)=>(0, $h97NM.goToBranch)(exploreMiniFieldWrapper, exploreMiniField, branchId);
    exploreMiniFieldWrapper.goToBranch = goToBranchFunction;
    exploreMiniField.goToBranch = goToBranchFunction;
    const goToBranchWithDistanceToScreenFunction = (branchId, distanceLeft, distanceTop)=>(0, $h97NM.goToBranchWithDistanceToScreen)(exploreMiniFieldWrapper, exploreMiniField, branchId, distanceLeft, distanceTop);
    exploreMiniFieldWrapper.goToBranchWithDistanceToScreen = goToBranchWithDistanceToScreenFunction;
    exploreMiniField.goToBranchWithDistanceToScreen = goToBranchWithDistanceToScreenFunction;
    const getBranchDistanceToScreenFunction = (branchId)=>(0, $h97NM.getBranchDistanceToScreen)(exploreMiniField, branchId);
    exploreMiniFieldWrapper.getBranchDistanceToScreen = getBranchDistanceToScreenFunction;
    exploreMiniField.getBranchDistanceToScreen = getBranchDistanceToScreenFunction;
    const getClosestBranchToScreenFunction = ()=>(0, $h97NM.getClosestBranchToScreen)(exploreMiniFieldWrapper, exploreMiniField);
    exploreMiniFieldWrapper.getClosestBranchToScreen = getClosestBranchToScreenFunction;
    exploreMiniField.getClosestBranchToScreen = getClosestBranchToScreenFunction;
    const createTreeConnectionsForAllFunction = ()=>(0, $25dWo.createTreeConnectionsForAll)(exploreMiniFieldWrapper);
    exploreMiniFieldWrapper.createTreeConnectionsForAll = createTreeConnectionsForAllFunction;
    exploreMiniField.createTreeConnectionsForAll = createTreeConnectionsForAllFunction;
    const truncateNameAndDescriptionFunction = ()=>(0, $25dWo.truncateNameAndDescription)(exploreMiniFieldWrapper);
    exploreMiniFieldWrapper.truncateNameAndDescription = truncateNameAndDescriptionFunction;
    exploreMiniField.truncateNameAndDescription = truncateNameAndDescriptionFunction;
    const getContentDimensionsFunction = ()=>$ac9538e28536dcab$var$getContentDimensions(branchAndLineage);
    exploreMiniFieldWrapper.getContentDimensions = getContentDimensionsFunction;
    exploreMiniField.getContentDimensions = getContentDimensionsFunction;
    const regsiterContentDimensionsFunction = ()=>$ac9538e28536dcab$var$regsiterContentDimensions(exploreMiniField);
    exploreMiniFieldWrapper.regsiterContentDimensions = regsiterContentDimensionsFunction;
    exploreMiniField.regsiterContentDimensions = regsiterContentDimensionsFunction;
    const registerZoomLimitFunction = ()=>$ac9538e28536dcab$var$registerZoomLimit(exploreMiniField);
    exploreMiniFieldWrapper.registerZoomLimit = registerZoomLimitFunction;
    exploreMiniField.registerZoomLimit = registerZoomLimitFunction;
    const setUpDimensionsFunction = ()=>$ac9538e28536dcab$var$setUpDimensions(exploreMiniFieldWrapper, exploreMiniField);
    exploreMiniFieldWrapper.setUpDimensions = setUpDimensionsFunction;
    exploreMiniField.setUpDimensions = setUpDimensionsFunction;
    const createZoomControllerFunction = ()=>(0, $lKhJ2.createZoomController)(exploreMiniFieldWrapper, exploreMiniField);
    exploreMiniFieldWrapper.createZoomController = createZoomControllerFunction;
    exploreMiniField.createZoomController = createZoomControllerFunction;
    const initiateAfterRenderFunction = ()=>$ac9538e28536dcab$var$initiateAfterRender(exploreMiniField);
    exploreMiniFieldWrapper.initiateAfterRender = initiateAfterRenderFunction;
    exploreMiniField.initiateAfterRender = initiateAfterRenderFunction;
    const replaceExploreContentWithNewInfoFunction = (familyInfo, addBuildFunctionsDictionary = null)=>$ac9538e28536dcab$var$replaceExploreContentWithNewInfo(exploreMiniField, branchAndLineage, familyInfo, addBuildFunctionsDictionary);
    exploreMiniFieldWrapper.replaceExploreContentWithNewInfo = replaceExploreContentWithNewInfoFunction;
    exploreMiniField.replaceExploreContentWithNewInfo = replaceExploreContentWithNewInfoFunction;
    return exploreMiniFieldWrapper;
}
function $ac9538e28536dcab$var$calculateMouseOffsetToParentElement(event, endParent) {
    const currentElement = event.target;
    const sumOfParentOffets = $ac9538e28536dcab$var$calcSumOfParentOffets(currentElement, endParent);
    return {
        x: event.offsetX + sumOfParentOffets.offsetLeft,
        y: event.offsetY + sumOfParentOffets.offsetTop
    };
}
function $ac9538e28536dcab$var$calcSumOfParentOffets(element, endParent) {
    if (element === endParent) return {
        offsetLeft: 0,
        offsetTop: 0
    };
    else {
        const nextOffset = $ac9538e28536dcab$var$calcSumOfParentOffets(element.offsetParent, endParent);
        return {
            offsetLeft: element.offsetLeft + nextOffset.offsetLeft,
            offsetTop: element.offsetTop + nextOffset.offsetTop
        };
    }
}
function $ac9538e28536dcab$var$setUpDimensions(exploreFieldWrapper, exploreField) {
    const minZoomValue = exploreField.minZoomValue;
    const additionalCoefficient = 1 / (1 - minZoomValue);
    let horizontalPadding = (exploreFieldWrapper.offsetWidth - exploreField.contentWidth * minZoomValue) / minZoomValue / 2;
    let verticalPadding = (exploreFieldWrapper.offsetHeight - exploreField.contentHeight * minZoomValue) / minZoomValue / 2;
    //const verticalPadding = exploreField.contentHeight * additionalCoefficient / 2;
    horizontalPadding = Math.max(0, horizontalPadding);
    verticalPadding = Math.max(0, verticalPadding);
    exploreField.horizontalPadding = horizontalPadding;
    exploreField.verticalPadding = verticalPadding;
    exploreField.style.padding = `${verticalPadding}px ${horizontalPadding}px`;
}
function $ac9538e28536dcab$var$getContentDimensions(firstBranch) {
    const contentWidth = firstBranch.offsetWidth;
    const contentHeight = firstBranch.offsetHeight;
    return {
        contentWidth: contentWidth,
        contentHeight: contentHeight
    };
}
function $ac9538e28536dcab$var$regsiterContentDimensions(exploreField) {
    const contentDimensions = exploreField.getContentDimensions();
    exploreField.contentWidth = contentDimensions.contentWidth;
    exploreField.contentHeight = contentDimensions.contentHeight;
}
function $ac9538e28536dcab$var$registerZoomLimit(exploreField) {
    /*
    exploreField.zoomLimitCoefficient = 650;

    const contentWidth = exploreField.contentWidth;
    const contentHeight = exploreField.contentHeight;

    const zoomLimitCoefficient = exploreField.zoomLimitCoefficient;

    exploreField.minZoomValue = Math.min(zoomLimitCoefficient/contentWidth*1.1, zoomLimitCoefficient/contentHeight*1.1, 0.8);
    exploreField.maxZoomValue = 2;

    exploreField.zoomScale = 1;
    */ const exploreFieldWrapper = exploreField.exploreFieldWrapper;
    const wrapperWidth = exploreFieldWrapper.offsetWidth;
    const wrapperHeight = exploreFieldWrapper.offsetHeight;
    const contentWidth = exploreField.contentWidth;
    const contentHeight = exploreField.contentHeight;
    const horizontalProportion = wrapperWidth / (contentWidth + 100);
    const verticalProportion = wrapperHeight / (contentHeight + 100);
    exploreField.minZoomValue = Math.min(horizontalProportion, verticalProportion, 0.8);
    exploreField.maxZoomValue = 2;
}
function $ac9538e28536dcab$var$initiateAfterRender(exploreField) {
    exploreField.truncateNameAndDescription();
    exploreField.regsiterContentDimensions();
    exploreField.registerZoomLimit();
    exploreField.setUpDimensions();
    exploreField.createZoomController();
    exploreField.createTreeConnectionsForAll();
    exploreField.zoomScale = 1;
}
function $ac9538e28536dcab$var$replaceExploreContentWithNewInfo(exploreField, content, familyInfo, addBuildFunctionsDictionary) {
    const closestBranchId = exploreField.getClosestBranchToScreen().branchId;
    const screenDistanceToClosestBranchId = exploreField.getBranchDistanceToScreen(closestBranchId);
    const oldLeftPos = exploreField.leftPos;
    const oldTopPos = exploreField.topPos;
    const oldZOom = exploreField.zoomScale;
    content.remove();
    content = null;
    const buildFunctionsDictionary = {};
    const sharedRevealParams = {};
    buildFunctionsDictionary.beforeRevealMore = (parentId)=>$ac9538e28536dcab$var$beforeRevealMore(sharedRevealParams, exploreField, parentId);
    buildFunctionsDictionary.onRevealMore = (parentId, newBranches, newBranchesDictionary)=>$ac9538e28536dcab$var$onRevealMore(sharedRevealParams, exploreField, parentId, newBranchesDictionary);
    if (addBuildFunctionsDictionary !== null) {
        if (addBuildFunctionsDictionary.onRevealMore !== null && addBuildFunctionsDictionary.onRevealMore instanceof Function) buildFunctionsDictionary.onRevealMore = (parentId, newBranches, newBranchesDictionary)=>{
            $ac9538e28536dcab$var$onRevealMore(sharedRevealParams, exploreField, parentId, newBranchesDictionary);
            addBuildFunctionsDictionary.onRevealMore(exploreField, newBranches);
        };
    }
    const newContent = (0, $25dWo.createBranchPreview)(familyInfo, null, buildFunctionsDictionary);
    exploreField.append(newContent);
    exploreField.exploreBranchesDictionary = newContent.exploreBranchesDictionary;
    exploreField.getContentDimensions = ()=>$ac9538e28536dcab$var$getContentDimensions(newContent);
    exploreField.replaceExploreContentWithNewInfo = (familyInfo, addBuildFunctionsDictionary = null)=>$ac9538e28536dcab$var$replaceExploreContentWithNewInfo(exploreField, newContent, familyInfo, addBuildFunctionsDictionary);
    const observer = new ResizeObserver((entries)=>{
        for (const entry of entries)if (entry.contentRect.width > 0 && entry.contentRect.height > 0) {
            exploreField.initiateAfterRender();
            exploreField.scaleExploreField(oldZOom);
            exploreField.goToBranchWithDistanceToScreen(closestBranchId, screenDistanceToClosestBranchId.distanceLeft, screenDistanceToClosestBranchId.distanceTop);
            observer.disconnect();
        }
    });
    observer.observe(exploreField.exploreFieldWrapper);
}
function $ac9538e28536dcab$var$initiateLineageDom(lineageDom, parentId) {
    lineageDom.parentId = parentId;
}
function $ac9538e28536dcab$var$beforeRevealMore(sharedRevealParams, exploreField, parentId) {
    const distanceToScreen = exploreField.getBranchDistanceToScreen(parentId);
    sharedRevealParams.distanceToScreen = distanceToScreen;
}
function $ac9538e28536dcab$var$onRevealMore(sharedRevealParams, exploreField, parentId, newBranchesDictionary) {
    const zoomController = exploreField.zoomController;
    const zoomScale = exploreField.zoomScale;
    const exploreBranchesDictionary = exploreField.exploreBranchesDictionary;
    for (const [key, value] of Object.entries(newBranchesDictionary))exploreBranchesDictionary[key] = value;
    $ac9538e28536dcab$var$deleteAllTreeConnections(exploreField);
    exploreField.truncateNameAndDescription();
    exploreField.regsiterContentDimensions();
    exploreField.registerZoomLimit();
    exploreField.setUpDimensions();
    exploreField.createTreeConnectionsForAll();
    zoomController.min = exploreField.minZoomValue;
    zoomController.max = exploreField.maxZoomValue;
    zoomController.value = zoomScale;
    const distanceToScreen = sharedRevealParams.distanceToScreen;
    exploreField.goToBranchWithDistanceToScreen(parentId, distanceToScreen.distanceLeft, distanceToScreen.distanceTop);
}
function $ac9538e28536dcab$var$deleteAllTreeConnections(exploreField) {
    const existingConnections = exploreField.querySelectorAll('.explore-window-branch-wrapper-lineage-link');
    for (let i of existingConnections)i.remove();
}
function $ac9538e28536dcab$export$fa0cb3da661b6169(element) {
    const explroeField = element.querySelector('explore-general-field');
    return explroeField;
}

});
parcelRegister("25dWo", function(module, exports) {

$parcel$export(module.exports, "createBranchPreview", () => $1846dcbe9c117702$export$f66e6d5b803fd046);
$parcel$export(module.exports, "drawLine", () => $1846dcbe9c117702$export$819db45aec5fcbe5);
$parcel$export(module.exports, "getParentBottomCenter", () => $1846dcbe9c117702$export$cfc962029a379518);
$parcel$export(module.exports, "getChildTopCenter", () => $1846dcbe9c117702$export$a6a175254e021b1);
$parcel$export(module.exports, "createTreeConnectionsForAll", () => $1846dcbe9c117702$export$cfe8153c2a103d2a);
$parcel$export(module.exports, "truncateNameAndDescription", () => $1846dcbe9c117702$export$d1037f951e8f9af);

var $5ZiIO = parcelRequire("5ZiIO");

var $iqZMU = parcelRequire("iqZMU");

var $450JE = parcelRequire("450JE");

var $5hf1P = parcelRequire("5hf1P");

var $7NPUP = parcelRequire("7NPUP");

var $bwCNb = parcelRequire("bwCNb");

var $czNeG = parcelRequire("czNeG");

var $053AO = parcelRequire("053AO");
function $1846dcbe9c117702$export$f66e6d5b803fd046(branchInfo, existingExploreBranchesDictionary = null, buildFunctionsDictionary = null) {
    const branchAndLineage = (0, $iqZMU.createElement)('div', null, [
        'explore-window-branch-wrapper'
    ]);
    let exploreBranchesDictionary = null;
    if (existingExploreBranchesDictionary !== null) exploreBranchesDictionary = existingExploreBranchesDictionary;
    else {
        exploreBranchesDictionary = {
            'primary-branch': null
        };
        branchAndLineage.exploreBranchesDictionary = exploreBranchesDictionary;
    }
    const branch = $1846dcbe9c117702$var$createBranchForExplore(branchInfo, exploreBranchesDictionary, buildFunctionsDictionary);
    if (existingExploreBranchesDictionary === null) exploreBranchesDictionary['primary-branch'] = branch;
    branchAndLineage.append(branch);
    if (branchInfo.childrenIds !== null && branchInfo.childrenIds !== undefined) {
        let ids;
        let lineageDom = null;
        if (branchInfo.children === null || branchInfo.children.length === 0) {
            const virginIds = (0, $5hf1P.deduceVirginIds)(branchInfo.childrenIds, branchInfo.children);
            ids = (0, $5hf1P.createIdsForRevealFromVirgins)(virginIds, 3);
            lineageDom = $1846dcbe9c117702$export$4fe82ee29da9def7(null, exploreBranchesDictionary, buildFunctionsDictionary);
            branchAndLineage.append(lineageDom);
            const revealBlock = (0, $450JE.createRevealChildrenBottom)(branchAndLineage, ids, buildFunctionsDictionary);
            revealBlock.parentId = branchInfo.id;
            lineageDom.append(revealBlock);
        } else if (branchInfo.children.length === branchInfo.childrenIds.length) {
            lineageDom = $1846dcbe9c117702$export$4fe82ee29da9def7(branchInfo.children, exploreBranchesDictionary, buildFunctionsDictionary);
            branchAndLineage.append(lineageDom);
        } else {
            const virginIds = (0, $5hf1P.deduceVirginIds)(branchInfo.childrenIds, branchInfo.children);
            ids = (0, $5hf1P.createIdsForRevealFromVirgins)(virginIds, 3);
            lineageDom = $1846dcbe9c117702$export$4fe82ee29da9def7(branchInfo.children, exploreBranchesDictionary, buildFunctionsDictionary);
            branchAndLineage.append(lineageDom);
            //lineage.insertAdjacentElement('afterbegin', createRevealMoreChildrenSide(branchAndLineage, ids, 'left'));
            const revealBlock = (0, $450JE.createRevealMoreChildrenSide)(branchAndLineage, ids, 'right', buildFunctionsDictionary);
            revealBlock.parentId = branchInfo.id;
            lineageDom.append(revealBlock);
        }
        lineageDom.parentId = branchInfo.id;
    }
    if (branchInfo.parent !== null && branchInfo.parent !== undefined) return $1846dcbe9c117702$var$createParents(branchAndLineage, branchInfo.parent, exploreBranchesDictionary, buildFunctionsDictionary);
    return branchAndLineage;
}
function $1846dcbe9c117702$var$createBranchForExplore(branchInfo, existingExploreBranchesDictionary = null, buildFunctionsDictionary = null) {
    const branch = (0, $iqZMU.createElement)('div', null, [
        'explore-window-branch'
    ]);
    try {
        const modStatus = branchInfo.modStatus;
        if (modStatus !== 'suspended' && modStatus !== 'banned') {
            const renderCheckList = new (0, $053AO.RenderCheckList)('text', 'preview');
            renderCheckList.setOnRenderComplete(()=>$1846dcbe9c117702$var$fadeLongDescription(branch));
            branch.renderCheckList = renderCheckList;
            const preview = (0, $iqZMU.createElement)('div', null, [
                'explore-window-branch-preview'
            ]);
            const previewElement = (0, $5ZiIO.createPreview)(branchInfo.preview, ()=>{
                renderCheckList.check('preview');
            });
            preview.append(previewElement);
            if (modStatus !== null) {
                if (modStatus === "plus_18") {
                    const black18Screen = (0, $czNeG.createPlus18Screen)(previewElement);
                    black18Screen.black18ScreenExplanation.remove();
                    black18Screen.black18ScreenQuestion.innerText = "Are you over 18 years old?";
                    black18Screen.create18WarningIconInBeginning();
                    black18Screen.makeIconRound();
                    preview.append(black18Screen);
                }
            }
            const name = (0, $iqZMU.createElement)('a', null, [
                'explore-window-branch-name'
            ]);
            name.innerText = branchInfo.name;
            name.href = (0, $7NPUP.SITE_URL) + "/branch/view-page/" + branchInfo.id;
            const description = (0, $iqZMU.createElement)('p', null, [
                'explore-window-branch-description'
            ]);
            description.innerText = branchInfo.description;
            branch.append(preview, name, description);
        } else {
            const restrictedBranchWindow = (0, $bwCNb.createContentRestrictedWindow)('Restricted by the moderation', null, [
                'explore-window-branch-restricted'
            ]);
            branch.append(restrictedBranchWindow);
        }
        existingExploreBranchesDictionary[branchInfo.id] = branch;
    } catch (error) {
        const restrictedBranchWindow = (0, $bwCNb.createContentRestrictedWindow)('An error occured displaying this branch', null, [
            'explore-window-branch-restricted'
        ]);
        branch.append(restrictedBranchWindow);
    }
    return branch;
}
function $1846dcbe9c117702$export$4fe82ee29da9def7(children = null, exploreBranchesDictionary = null, buildFunctionsDictionary) {
    const branchHeritage = (0, $iqZMU.createElement)('div', null, [
        'explore-window-branch-wrapper-lineage'
    ]);
    if (children === null) return branchHeritage;
    let childrenElements = [];
    for (let child of children)childrenElements.push($1846dcbe9c117702$export$f66e6d5b803fd046(child, exploreBranchesDictionary, buildFunctionsDictionary));
    branchHeritage.append(...childrenElements);
    return branchHeritage;
}
function $1846dcbe9c117702$var$createParents(branchAndLineage, firstParent, existingExploreBranchesDictionary = null, buildFunctionsDictionary = null) {
    const parentBranchAndLineage = (0, $iqZMU.createElement)('div', null, [
        'explore-window-branch-wrapper'
    ]);
    const parentLineage = $1846dcbe9c117702$export$4fe82ee29da9def7(null, existingExploreBranchesDictionary, buildFunctionsDictionary);
    const branch = $1846dcbe9c117702$var$createBranchForExplore(firstParent, existingExploreBranchesDictionary, buildFunctionsDictionary);
    parentLineage.append(branchAndLineage);
    parentBranchAndLineage.append(branch);
    parentBranchAndLineage.append(parentLineage);
    if (firstParent.parent !== null && firstParent.parent !== undefined) return $1846dcbe9c117702$var$createParents(parentBranchAndLineage, firstParent.parent, existingExploreBranchesDictionary, buildFunctionsDictionary);
    else parentBranchAndLineage.exploreBranchesDictionary = existingExploreBranchesDictionary;
    return parentBranchAndLineage;
}
function $1846dcbe9c117702$export$819db45aec5fcbe5(ctx, startX, startY, midX, midY, endX, endY) {
    ctx.beginPath();
    ctx.moveTo(startX, startY);
    ctx.lineTo(startX, midY); // Vertical down from parent
    ctx.lineTo(endX, midY); // Horizontal to child
    ctx.lineTo(endX, endY); // Vertical down to child
    ctx.strokeStyle = "black";
    ctx.lineWidth = 2;
    ctx.stroke();
}
function $1846dcbe9c117702$export$cfc962029a379518(element, container) {
    return {
        x: element.offsetLeft + element.offsetWidth / 2,
        y: element.offsetTop + element.offsetHeight // Bottom vertical position
    };
}
function $1846dcbe9c117702$export$a6a175254e021b1(element, container) {
    return {
        x: element.offsetLeft + element.offsetWidth / 2,
        y: element.offsetTop // Top vertical position
    };
}
function $1846dcbe9c117702$var$getMargin(element) {
    const styles = window.getComputedStyle(element);
    const marginTop = parseInt(styles.marginTop, 10);
    const marginRight = parseInt(styles.marginRight, 10);
    const marginBottom = parseInt(styles.marginBottom, 10);
    const marginLeft = parseInt(styles.marginLeft, 10);
    return {
        marginTop: marginTop,
        marginRight: marginRight,
        marginBottom: marginBottom,
        marginLeft: marginLeft
    };
}
function $1846dcbe9c117702$export$cfe8153c2a103d2a(exploreFieldWrapper) {
    const existingConnections = exploreFieldWrapper.querySelectorAll('.explore-window-branch-wrapper-lineage-link');
    for (let i of existingConnections)i.remove();
    const allWrappers = exploreFieldWrapper.querySelectorAll('.explore-window-branch-wrapper');
    for (let wrapper of allWrappers){
        const linage = wrapper.querySelector('.explore-window-branch-wrapper-lineage');
        if (linage) {
            const parent = wrapper.querySelector('.explore-window-branch');
            const children = linage.children;
            const wrapperMargins = $1846dcbe9c117702$var$getMargin(wrapper);
            const wrapperMarginRight = wrapperMargins.marginRight;
            const wrapperMarginLeft = wrapperMargins.marginLeft;
            // Create and configure canvas
            const canvas = document.createElement("canvas");
            canvas.classList.add("explore-window-branch-wrapper-lineage-link");
            canvas.width = wrapper.offsetWidth - wrapperMarginRight - wrapperMarginLeft;
            canvas.height = 50;
            const ctx = canvas.getContext("2d");
            const parentCenter = $1846dcbe9c117702$export$cfc962029a379518(parent, wrapper);
            for (let child of children){
                const childCenter = $1846dcbe9c117702$export$a6a175254e021b1(child, wrapper);
                // Midpoint for the zig-zag connection
                const midY = parentCenter.y + (childCenter.y - parentCenter.y) / 2;
                $1846dcbe9c117702$export$819db45aec5fcbe5(ctx, parentCenter.x, 0, parentCenter.x, canvas.height / 2, childCenter.x, canvas.height);
            }
            parent.insertAdjacentElement('afterend', canvas);
        }
    }
}
function $1846dcbe9c117702$export$d1037f951e8f9af(exploreFieldWrapper) {
    const allNames = exploreFieldWrapper.querySelectorAll('.explore-window-branch-name');
    const allBranches = exploreFieldWrapper.querySelectorAll('.explore-window-branch');
    for (let i of allNames)$1846dcbe9c117702$var$truncateText(i, 18);
    for (let i of allBranches){
        const renderCheckList = i.renderCheckList;
        if (renderCheckList) i.renderCheckList.check('text');
    }
}
function $1846dcbe9c117702$var$truncateText(el, maxLetters) {
    let originalText = el.innerText;
    while(originalText.length > maxLetters){
        el.innerText = originalText + '...';
        originalText = originalText.slice(0, -1);
    }
}
function $1846dcbe9c117702$var$fadeLongDescription(branchElement) {
    if (branchElement.scrollHeight > branchElement.clientHeight) {
        const collapseGradient = (0, $iqZMU.createElement)('div', null, [
            'explore-window-branch-collapsed-gradient'
        ]);
        branchElement.classList.add('explore-window-branch-collapsed');
        branchElement.append(collapseGradient);
    }
}

});
parcelRegister("450JE", function(module, exports) {

$parcel$export(module.exports, "createRevealChildrenBottom", () => $2f8833175649d492$export$47840d15596dba30);
$parcel$export(module.exports, "createRevealMoreChildrenSide", () => $2f8833175649d492$export$efab9037f5d5c0df);

var $81Clf = parcelRequire("81Clf");

var $25dWo = parcelRequire("25dWo");

var $7NPUP = parcelRequire("7NPUP");

var $iqZMU = parcelRequire("iqZMU");

var $5hf1P = parcelRequire("5hf1P");

var $cCBwI = parcelRequire("cCBwI");
const $2f8833175649d492$var$sideDictionary = {
    'left': 'explore-window-branch-reveal-children-left',
    'right': 'explore-window-branch-reveal-children-right'
};
function $2f8833175649d492$export$47840d15596dba30(parentWrapper, ids, buildFunctionsDictionary = null) {
    const revealButton = (0, $iqZMU.createElement)('div', null, [
        'explore-window-branch-reveal-children',
        'explore-window-branch-reveal-children-bottom'
    ]);
    const revealButtonCaption = (0, $iqZMU.createElement)('p', null, null);
    revealButtonCaption.innerText = `+${ids.toReveal.length + ids.toRevealLater.length} children`;
    revealButton.append(revealButtonCaption);
    (0, $81Clf.makeNewButton)(revealButton, 'rgb(58, 58, 58)', 'white', null, 'lighten', null);
    revealButton.addEventListener('click', ()=>$2f8833175649d492$var$revealMoreChildren(parentWrapper, ids, buildFunctionsDictionary));
    return revealButton;
}
function $2f8833175649d492$export$efab9037f5d5c0df(parentWrapper, ids, side, buildFunctionsDictionary = null) {
    const revealButton = (0, $iqZMU.createElement)('div', null, [
        $2f8833175649d492$var$sideDictionary[side],
        'explore-window-branch-reveal-children-side',
        'explore-window-branch-reveal-children'
    ]);
    const revealButtonCaption = (0, $iqZMU.createElement)('p', null, null);
    revealButtonCaption.innerText = `+${ids.toReveal.length + ids.toRevealLater.length} children`;
    revealButton.append(revealButtonCaption);
    (0, $81Clf.makeNewButton)(revealButton, 'rgb(58, 58, 58)', 'white', null, 'lighten', null);
    revealButton.addEventListener('click', ()=>$2f8833175649d492$var$revealMoreChildren(parentWrapper, ids, buildFunctionsDictionary));
    return revealButton;
}
async function $2f8833175649d492$var$revealMoreChildren(parentWrapper, ids, buildFunctionsDictionary = null) {
    console.log("revealing ids", ids);
    const dataBranches = await $2f8833175649d492$var$getNodesByIds(ids.toReveal);
    const parent = parentWrapper.querySelector('.explore-window-branch');
    const lineage = parentWrapper.querySelector('.explore-window-branch-wrapper-lineage');
    if (buildFunctionsDictionary !== null && buildFunctionsDictionary.beforeRevealMore !== null && buildFunctionsDictionary.beforeRevealMore instanceof Function) {
        const beforeRevealMoreFunction = ()=>buildFunctionsDictionary.beforeRevealMore(lineage.parentId);
        beforeRevealMoreFunction();
    }
    const newBranchesDictionary = {};
    const newBranches = [];
    for (let newBranch of dataBranches){
        const newBranchWrapper = (0, $25dWo.createBranchPreview)(newBranch, null, buildFunctionsDictionary);
        const newBranchElement = newBranchWrapper.exploreBranchesDictionary[newBranch.id];
        newBranches.push(newBranchWrapper);
        newBranchesDictionary[newBranch.id] = newBranchElement;
    }
    for (let i of lineage.children)if (i.classList.contains('explore-window-branch-reveal-children')) i.remove();
    if (!(ids.toRevealLater === null || ids.toRevealLater.length === 0)) {
        ids = (0, $5hf1P.createIdsForRevealFromVirgins)(ids.toRevealLater, 3);
        //lineage.insertAdjacentElement('afterbegin', createRevealMoreChildrenSide(parentWrapper, ids, 'left'));
        newBranches.push($2f8833175649d492$export$efab9037f5d5c0df(parentWrapper, ids, 'right', buildFunctionsDictionary));
    }
    lineage.append(...newBranches);
    console.log("dataBranches ", dataBranches);
    if (buildFunctionsDictionary !== null && buildFunctionsDictionary.onRevealMore !== null && buildFunctionsDictionary.onRevealMore instanceof Function) {
        const onRevealMoreFunction = (dataBranches, newBranchesDictionary)=>buildFunctionsDictionary.onRevealMore(lineage.parentId, dataBranches, newBranchesDictionary);
        onRevealMoreFunction(dataBranches, newBranchesDictionary);
    }
}
async function $2f8833175649d492$var$getNodesByIds(...ids) {
    const url = new URL((0, $7NPUP.API_GATEWAY) + 'branches/get/list/by-ids'); // Base URL
    ids.forEach((id)=>url.searchParams.append("list", id));
    const response = await fetch(url, {
        method: 'GET'
    });
    if (response.status === 200) return response.json();
    else {
        (0, $cCBwI.insertPlaqueAndAlertWindow)("Something went wrong while loading up more children!");
        return null;
    }
}
function $2f8833175649d492$var$redrawTheFamilyTree(parent, lineage, wrapper) {
    wrapper.querySelector('.explore-window-branch-wrapper-lineage-link').remove();
    const children = lineage.children;
    // Create and configure canvas
    const canvas = document.createElement("canvas");
    canvas.classList.add("explore-window-branch-wrapper-lineage-link");
    canvas.width = wrapper.clientWidth;
    canvas.height = 50;
    const ctx = canvas.getContext("2d");
    const parentCenter = (0, $25dWo.getParentBottomCenter)(parent, wrapper);
    for (let child of children){
        const childCenter = (0, $25dWo.getChildTopCenter)(child, wrapper);
        // Midpoint for the zig-zag connection
        const midY = parentCenter.y + (childCenter.y - parentCenter.y) / 2;
        (0, $25dWo.drawLine)(ctx, parentCenter.x, 0, parentCenter.x, canvas.height / 2, childCenter.x, canvas.height);
    }
    parent.insertAdjacentElement('afterend', canvas);
}
function $2f8833175649d492$var$findExploreFieldThroughParents(element) {
    while(!element.classList.contains('explore-mini-field'))element = element.parentElement;
    return element;
}

});
parcelRegister("5hf1P", function(module, exports) {

$parcel$export(module.exports, "deduceVirginIds", () => $3d7a329e7a47f0b4$export$bdb2ae0be68bc2f);
$parcel$export(module.exports, "createIdsForRevealFromVirgins", () => $3d7a329e7a47f0b4$export$b2d78c5bafaadf71);
function $3d7a329e7a47f0b4$export$bdb2ae0be68bc2f(childrenIds, children) {
    const virgins = [];
    if (children === null) return childrenIds;
    for (let i of childrenIds)if (!$3d7a329e7a47f0b4$var$checkIfIdIsInChildren(i, children)) virgins.push(i);
    return virgins;
}
function $3d7a329e7a47f0b4$export$b2d78c5bafaadf71(virgins, revealAmount) {
    const toRevealArray = [];
    const toRevealLaterArray = [];
    for(let i in virgins)if (i < revealAmount) toRevealArray.push(virgins[i]);
    else toRevealLaterArray.push(virgins[i]);
    const idsObject = {
        toReveal: toRevealArray,
        toRevealLater: toRevealLaterArray
    };
    return idsObject;
}
function $3d7a329e7a47f0b4$var$checkIfIdIsInChildren(id, children) {
    for (let i of children){
        if (i.id === id) return true;
    }
    return false;
}

});


parcelRegister("bwCNb", function(module, exports) {

$parcel$export(module.exports, "createContentRestrictedWindow", () => $8640c62e9f906f66$export$5820da5174b65faa);

var $iqZMU = parcelRequire("iqZMU");
function $8640c62e9f906f66$export$5820da5174b65faa(message, id = null, classArray = null) {
    let newClassArray;
    if (classArray === null) newClassArray = [
        'content-restricted-window'
    ];
    else newClassArray = classArray.concat([
        'content-restricted-window'
    ]);
    const contentRestrictedWindow = (0, $iqZMU.createElement)('div', id, newClassArray);
    const contentRestrictedImg = (0, $iqZMU.createElement)('img', null, null);
    contentRestrictedImg.src = '/images/forbidden/forbidden.png';
    const contentRestrictedCaption = (0, $iqZMU.createElement)('p', null, null);
    contentRestrictedCaption.innerText = message;
    contentRestrictedWindow.append(contentRestrictedImg, contentRestrictedCaption);
    return contentRestrictedWindow;
}

});

parcelRegister("053AO", function(module, exports) {

$parcel$export(module.exports, "RenderCheckList", () => $00f34132946f7e30$export$21e01c85c5aa97e);
class $00f34132946f7e30$export$21e01c85c5aa97e {
    #booleanCheckList;
    #onRenderComplete = null;
    constructor(checkNames = []){
        this.#booleanCheckList = new Map();
        if (Array.isArray(checkNames)) // Case: passed an array
        for (let i of checkNames)this.addCheck(i);
        else if (typeof checkNames === "string") // Case: passed a single string
        this.addCheck(checkNames);
        else if (arguments.length > 1) // Case: passed multiple strings (spread)
        for (let i of arguments)this.addCheck(i);
        else if (checkNames !== undefined) throw new TypeError("Constructor only accepts an array or strings");
    }
    addCheck(checkName) {
        this.#booleanCheckList.set(checkName, false);
    }
    checkAll() {
        const checkEntries = this.#booleanCheckList.entries();
        let allChecked = true;
        for (const [key, value] of checkEntries)if (value === false) allChecked = false;
        if (allChecked) this.#onRenderComplete();
    }
    check(checkName) {
        if (this.#booleanCheckList.has(checkName)) {
            this.#booleanCheckList.set(checkName, true);
            this.checkAll();
        }
    }
    setOnRenderComplete(onRenderFunction) {
        if (onRenderFunction instanceof Function) this.#onRenderComplete = onRenderFunction;
        else throw new TypeError("You need to assign a function!");
    }
}

});


parcelRegister("c2VNi", function(module, exports) {

$parcel$export(module.exports, "mouseDownDragExplore", () => $8c5280a2386e9453$export$e0983cb921e9dded);
$parcel$export(module.exports, "mouseMoveDragExplore", () => $8c5280a2386e9453$export$64cb96aae373756c);
$parcel$export(module.exports, "mouseUpDragExplore", () => $8c5280a2386e9453$export$ef7be73b62e7c121);
parcelRequire("h97NM");
let $8c5280a2386e9453$var$selectedExplore = null;
let $8c5280a2386e9453$var$xDifference = 0, $8c5280a2386e9453$var$yDifference = 0;
const $8c5280a2386e9453$var$excludedListByClass = [
    'explore-window-branch',
    'explore-window-branch-reveal-children',
    'explore-zoom-controller'
];
function $8c5280a2386e9453$export$e0983cb921e9dded(e) {
    e.preventDefault();
    const elements = document.elementsFromPoint(e.clientX, e.clientY);
    if (!$8c5280a2386e9453$var$checkIfElementsBelowContainClasses(elements)) {
        e.preventDefault();
        $8c5280a2386e9453$var$selectedExplore = $8c5280a2386e9453$var$findFirstExploreInElements(document.elementsFromPoint(e.clientX, e.clientY));
        $8c5280a2386e9453$var$xDifference = e.clientX - $8c5280a2386e9453$var$selectedExplore.offsetLeft;
        $8c5280a2386e9453$var$yDifference = e.clientY - $8c5280a2386e9453$var$selectedExplore.offsetTop;
    }
}
function $8c5280a2386e9453$export$64cb96aae373756c(e) {
    if ($8c5280a2386e9453$var$selectedExplore !== null) {
        const leftPos = e.clientX - $8c5280a2386e9453$var$xDifference;
        const topPos = e.clientY - $8c5280a2386e9453$var$yDifference;
        const exploreWrapper = $8c5280a2386e9453$var$selectedExplore.parentElement;
        $8c5280a2386e9453$var$selectedExplore.moveExploreFieldTo(-leftPos, -topPos);
    }
}
function $8c5280a2386e9453$export$ef7be73b62e7c121(e) {
    if ($8c5280a2386e9453$var$selectedExplore !== null) $8c5280a2386e9453$var$selectedExplore = null;
}
function $8c5280a2386e9453$var$findFirstExploreInElements(elements) {
    let element = null;
    for (let i of elements)if (i.classList.contains('explore-general-field')) element = i;
    return element;
}
function $8c5280a2386e9453$var$checkIfElementsBelowContainClasses(elements) {
    for (let i of elements)for (let j of $8c5280a2386e9453$var$excludedListByClass){
        if (i.classList.contains(j)) return true;
    }
}

});
parcelRegister("h97NM", function(module, exports) {

$parcel$export(module.exports, "getExploreCoordinates", () => $c7b95437547bfc43$export$d0dc60a1263682f1);
$parcel$export(module.exports, "moveExploreToCoordinates", () => $c7b95437547bfc43$export$3f37a431fd95695a);
$parcel$export(module.exports, "moveExploreFieldTo", () => $c7b95437547bfc43$export$935cbcdd8ba60fe9);
$parcel$export(module.exports, "centerExploreFieldAroundTheBranch", () => $c7b95437547bfc43$export$36fd0c5889c8b093);
$parcel$export(module.exports, "goToBranch", () => $c7b95437547bfc43$export$3c7ac34a75d3b435);
$parcel$export(module.exports, "goToBranchWithDistanceToScreen", () => $c7b95437547bfc43$export$fff5a87f4f4e15a);
$parcel$export(module.exports, "getBranchDistanceToScreen", () => $c7b95437547bfc43$export$1289c4701e95120);
$parcel$export(module.exports, "getClosestBranchToScreen", () => $c7b95437547bfc43$export$229813709fb24965);
$parcel$export(module.exports, "scaleExploreField", () => $c7b95437547bfc43$export$c0a350729b92c72b);
$parcel$export(module.exports, "scaleExploreFieldBy", () => $c7b95437547bfc43$export$7f971ce1c8f54f76);
function $c7b95437547bfc43$export$d0dc60a1263682f1(exploreFieldWrapper, exploreField) {
    const oldScale = exploreField.zoomScale;
    const oldLeft = exploreField.leftPos;
    const oldTop = exploreField.topPos;
    const x = (oldLeft - exploreField.offsetWidth / 2 * (1 - oldScale)) / oldScale;
    const y = (oldTop - exploreField.offsetHeight / 2 * (1 - oldScale)) / oldScale;
    return {
        x: x,
        y: y
    };
}
function $c7b95437547bfc43$export$3f37a431fd95695a(exploreFieldWrapper, exploreField, x = null, y = null) {
    const zoomLevel = exploreField.zoomScale;
    const coordinates = $c7b95437547bfc43$export$d0dc60a1263682f1(exploreFieldWrapper, exploreField);
    const xOld = coordinates.x;
    const yOld = coordinates.y;
    const oldLeft = exploreField.leftPos;
    const oldTop = exploreField.topPos;
    let leftPos = oldLeft + (x - xOld) * zoomLevel;
    let topPos = oldTop + (y - yOld) * zoomLevel;
    $c7b95437547bfc43$export$935cbcdd8ba60fe9(exploreFieldWrapper, exploreField, leftPos, topPos);
}
function $c7b95437547bfc43$export$935cbcdd8ba60fe9(exploreFieldWrapper, exploreField, leftPos = null, topPos = null) {
    const minZoomValue = exploreField.minZoomValue;
    const maxZoomValue = exploreField.maxZoomValue;
    const zoomLevel = exploreField.zoomScale;
    const horizontalFreedom = exploreField.offsetWidth - exploreFieldWrapper.offsetWidth;
    const verticalFreedom = exploreField.offsetHeight - exploreFieldWrapper.offsetHeight;
    const horizontalLimitAtMin = exploreField.offsetWidth / 2 * (1 - zoomLevel);
    const horizontalLimitAtMax = horizontalLimitAtMin + exploreField.horizontalPadding * zoomLevel;
    const verticalLimitAtMin = exploreField.offsetHeight / 2 * (1 - zoomLevel);
    const verticalLimitAtMax = verticalLimitAtMin + exploreField.verticalPadding * zoomLevel;
    const additionalHorizontalLimit = (horizontalLimitAtMax - horizontalLimitAtMin) / (maxZoomValue - minZoomValue) * (zoomLevel - minZoomValue) + horizontalLimitAtMin;
    const additionalVerticalLimit = (verticalLimitAtMax - verticalLimitAtMin) / (maxZoomValue - minZoomValue) * (zoomLevel - minZoomValue) + verticalLimitAtMin;
    let limitCoefficient = 1;
    if (zoomLevel > 1) limitCoefficient = Math.log2(1 / zoomLevel) / 2;
    if (leftPos !== null) {
        leftPos = -leftPos;
        if (leftPos > 0 - additionalHorizontalLimit) leftPos = 0 - additionalHorizontalLimit;
        else if (leftPos < additionalHorizontalLimit - horizontalFreedom) leftPos = additionalHorizontalLimit - horizontalFreedom;
        exploreField.style.left = leftPos + 'px';
        exploreField.leftPos = -leftPos;
    }
    if (topPos !== null) {
        topPos = -topPos;
        if (topPos > 0 - additionalVerticalLimit) topPos = 0 - additionalVerticalLimit;
        else if (topPos < additionalVerticalLimit - verticalFreedom) topPos = additionalVerticalLimit - verticalFreedom;
        exploreField.style.top = topPos + 'px';
        exploreField.topPos = -topPos;
    }
}
function $c7b95437547bfc43$export$36fd0c5889c8b093(exploreFieldWrapper, branchId) {
    const exploreField = exploreFieldWrapper.exploreField;
    console.log("explore dictionary", exploreField.exploreBranchesDictionary);
    if (exploreField.exploreBranchesDictionary === null || exploreField.exploreBranchesDictionary === undefined) return null;
    const branch = exploreField.exploreBranchesDictionary[branchId];
    const offsetLeftTotal = $c7b95437547bfc43$var$getOffsetLeftRelativeTo(branch, exploreField);
    const offsetTopTotal = $c7b95437547bfc43$var$getOffsetTopRelativeTo(branch, exploreField);
    let newLeft = offsetLeftTotal - exploreFieldWrapper.offsetWidth / 2 + branch.offsetWidth / 2;
    //let newTop = -(offsetTopTotal - exploreFieldWrapper.offsetHeight/2 +  branch.offsetHeight/2);
    let newTop = offsetTopTotal;
    if (newLeft > exploreField.offsetWidth - exploreFieldWrapper.offsetWidth) newLeft = -exploreFieldWrapper.offsetWidth + branch.offsetWidth / 2;
    if (newTop > exploreField.offsetHeight - exploreFieldWrapper.offsetHeight) {
        console.log("haha vertical");
        //newTop = newTop + branch.offsetHeight/2;
        newTop = newTop + branch.offsetHeight;
    }
    exploreFieldWrapper.moveExploreFieldTo(newLeft, newTop);
}
function $c7b95437547bfc43$export$3c7ac34a75d3b435(exploreFieldWrapper, exploreField, branchId) {
    const zoomLevel = exploreField.zoomScale;
    const branch = exploreField.exploreBranchesDictionary[branchId];
    const offsetLeftTotal = $c7b95437547bfc43$var$getOffsetLeftRelativeTo(branch, exploreField);
    const offsetTopTotal = $c7b95437547bfc43$var$getOffsetTopRelativeTo(branch, exploreField);
    const newLeft = offsetLeftTotal * (1 - zoomLevel);
    const newTop = offsetTopTotal * (1 - zoomLevel);
    $c7b95437547bfc43$export$3f37a431fd95695a(exploreFieldWrapper, exploreField, offsetLeftTotal, offsetTopTotal);
}
function $c7b95437547bfc43$export$fff5a87f4f4e15a(exploreFieldWrapper, exploreField, branchId, distanceLeft, distanceTop) {
    const zoomLevel = exploreField.zoomScale;
    const branch = exploreField.exploreBranchesDictionary[branchId];
    const offsetLeftTotal = $c7b95437547bfc43$var$getOffsetLeftRelativeTo(branch, exploreField);
    const offsetTopTotal = $c7b95437547bfc43$var$getOffsetTopRelativeTo(branch, exploreField);
    const newLeft = offsetLeftTotal * zoomLevel - distanceLeft + exploreField.offsetWidth / 2 * (1 - zoomLevel);
    const newTop = offsetTopTotal * zoomLevel - distanceTop + exploreField.offsetHeight / 2 * (1 - zoomLevel);
    $c7b95437547bfc43$export$935cbcdd8ba60fe9(exploreFieldWrapper, exploreField, newLeft, newTop);
}
function $c7b95437547bfc43$export$1289c4701e95120(exploreField, branchId) {
    const leftPos = exploreField.leftPos;
    const topPos = exploreField.topPos;
    const zoomLevel = exploreField.zoomScale;
    const branch = exploreField.exploreBranchesDictionary[branchId];
    const offsetLeftTotal = $c7b95437547bfc43$var$getOffsetLeftRelativeTo(branch, exploreField);
    const offsetTopTotal = $c7b95437547bfc43$var$getOffsetTopRelativeTo(branch, exploreField);
    const distanceLeft = offsetLeftTotal * zoomLevel - (leftPos - exploreField.offsetWidth / 2 * (1 - zoomLevel));
    const distanceTop = offsetTopTotal * zoomLevel - (topPos - exploreField.offsetHeight / 2 * (1 - zoomLevel));
    return {
        distanceLeft: distanceLeft,
        distanceTop: distanceTop
    };
}
function $c7b95437547bfc43$var$getExplorePointOnTheScreen(exploreField, leftScreenCoord, topScreenCoord) {
    const leftPos = exploreField.leftPos;
    const topPos = exploreField.topPos;
    const scale = exploreField.zoomScale;
    const offsetLeft = (leftPos + leftScreenCoord - exploreField.offsetWidth / 2 * (1 - scale)) / scale;
    const offsetTop = (topPos + topScreenCoord - exploreField.offsetHeight / 2 * (1 - scale)) / scale;
    return {
        offsetLeft: offsetLeft,
        offsetTop: offsetTop
    };
}
function $c7b95437547bfc43$var$getExplorePointOnTheScreenFromCenter(exploreFieldWrapper, exploreField, xCoord, yCoord) {
    return $c7b95437547bfc43$var$getExplorePointOnTheScreen(exploreField, exploreFieldWrapper.offsetWidth / 2 + xCoord, exploreFieldWrapper.offsetHeight / 2 + yCoord);
}
function $c7b95437547bfc43$export$229813709fb24965(exploreFieldWrapper, exploreField) {
    const branchDictionary = exploreField.exploreBranchesDictionary;
    const screenCentreOffset = $c7b95437547bfc43$var$getExplorePointOnTheScreenFromCenter(exploreFieldWrapper, exploreField, 0, 0);
    const closestBranch = {};
    closestBranch.distance = Math.max(exploreField.offsetHeight, exploreField.offsetWidth, 0);
    for (const [branchId, branchElement] of Object.entries(branchDictionary)){
        const distanceToBranchCentre = $c7b95437547bfc43$var$ExploreMovementUtility.getElementCentreCoordinates(exploreField, branchElement);
        const distance = Math.sqrt((screenCentreOffset.offsetLeft - distanceToBranchCentre.offsetLeft) ** 2 + (screenCentreOffset.offsetTop - distanceToBranchCentre.offsetTop) ** 2);
        if (distance < closestBranch.distance) {
            closestBranch.distance = distance;
            closestBranch.branchId = branchId;
            closestBranch.branchElement = branchElement;
        }
    }
    return closestBranch;
}
function $c7b95437547bfc43$var$getOffsetLeftRelativeTo(targetElement, containerElement) {
    let offset = 0;
    let current = targetElement;
    while(current && current !== containerElement){
        offset += current.offsetLeft;
        current = current.offsetParent;
    }
    // If we never found the containerElement in the offsetParent chain
    if (current !== containerElement) {
        console.warn('Container not found in offsetParent chain.');
        return null;
    }
    return offset;
}
function $c7b95437547bfc43$var$getOffsetTopRelativeTo(targetElement, containerElement) {
    let offset = 0;
    let current = targetElement;
    while(current && current !== containerElement){
        offset += current.offsetTop;
        current = current.offsetParent;
    }
    // If we never found the containerElement in the offsetParent chain
    if (current !== containerElement) {
        console.warn('Container not found in offsetParent chain.');
        return null;
    }
    return offset;
}
function $c7b95437547bfc43$export$c0a350729b92c72b(exploreField, scale) {
    if (scale <= 0) return false;
    const minZoomValue = exploreField.minZoomValue;
    const maxZoomValue = exploreField.maxZoomValue;
    if (scale <= minZoomValue) scale = minZoomValue;
    else if (scale >= maxZoomValue) scale = maxZoomValue;
    exploreField.style.transform = `scale(${scale})`;
    exploreField.zoomScale = scale;
    const scaleControllerInput = exploreField.zoomController;
    scaleControllerInput.value = scale;
}
function $c7b95437547bfc43$export$7f971ce1c8f54f76(exploreField, scaleChange) {
    if (exploreField.zoomScale === null || exploreField.zoomScale === undefined) exploreField.zoomScale = 1;
    const newScale = exploreField.zoomScale * scaleChange;
    //console.log("scaleExploreFieldBy: ", exploreField.zoomScale, scaleChange);
    $c7b95437547bfc43$export$c0a350729b92c72b(exploreField, newScale);
}
/*
function checkScaleAgainstBaseDimensions(exploreField, scale) {
    if(scale<=0)
        return false;

    const minZoomValue = exploreField.minZoomValue;
    const maxZoomValue = exploreField.maxZoomValue;

    if(scale<minZoomValue){
        exploreField.scaleExploreField(minZoomValue);
        return false;
    }

    if(scale>maxZoomValue){
        exploreField.scaleExploreField(maxZoomValue);
        return false;
    }

    return true;
}
    */ class $c7b95437547bfc43$var$ExploreMovementUtility {
    static getOffsetLeftRelativeTo(targetElement, containerElement) {
        let offset = 0;
        let current = targetElement;
        while(current && current !== containerElement){
            offset += current.offsetLeft;
            current = current.offsetParent;
        }
        // If we never found the containerElement in the offsetParent chain
        if (current !== containerElement) {
            console.warn('Container not found in offsetParent chain.');
            return null;
        }
        return offset;
    }
    static getOffsetTopRelativeTo(targetElement, containerElement) {
        let offset = 0;
        let current = targetElement;
        while(current && current !== containerElement){
            offset += current.offsetTop;
            current = current.offsetParent;
        }
        // If we never found the containerElement in the offsetParent chain
        if (current !== containerElement) {
            console.warn('Container not found in offsetParent chain.');
            return null;
        }
        return offset;
    }
    static getElementCentreCoordinates(explroeField, element) {
        const offsetLeft = this.getOffsetLeftRelativeTo(element, explroeField);
        const offsetTop = this.getOffsetTopRelativeTo(element, explroeField);
        return {
            offsetLeft: offsetLeft + element.offsetWidth / 2,
            offsetTop: offsetTop + element.offsetHeight / 2
        };
    }
}

});


parcelRegister("lKhJ2", function(module, exports) {

$parcel$export(module.exports, "createZoomController", () => $fd4ba4ba65b6c404$export$cbab80ed201aea81);

var $iqZMU = parcelRequire("iqZMU");
function $fd4ba4ba65b6c404$export$cbab80ed201aea81(exploreFieldWrapper, exploreField) {
    const existingZoomController = exploreFieldWrapper.zoomController;
    if (existingZoomController !== null && existingZoomController !== undefined) return;
    const exploreZoomController = (0, $iqZMU.createElement)('div', null, [
        'explore-zoom-controller'
    ]);
    const exploreZoomControllerCaption = (0, $iqZMU.createElement)('p', null, [
        'explore-zoom-controller-caption'
    ]);
    exploreZoomControllerCaption.innerText = 'Scale';
    const exploreZoomControllerInputWrapper = (0, $iqZMU.createElement)('div', null, [
        'explore-zoom-controller-input-wrapper'
    ]);
    const exploreZoomControllerInput = (0, $iqZMU.createElement)('input', null, [
        'explore-zoom-controller-input'
    ]);
    exploreZoomControllerInput.type = 'range';
    const minZoomValue = exploreField.minZoomValue;
    const maxZoomValue = exploreField.maxZoomValue;
    exploreZoomControllerInput.min = minZoomValue;
    exploreZoomControllerInput.max = maxZoomValue;
    exploreZoomControllerInput.step = 0.01;
    exploreZoomControllerInput.value = 1;
    exploreZoomControllerInputWrapper.append(exploreZoomControllerInput);
    exploreZoomController.append(exploreZoomControllerCaption);
    exploreZoomController.append(exploreZoomControllerInputWrapper);
    exploreZoomControllerInput.addEventListener('input', ()=>{
        const oldScale = exploreField.zoomScale;
        const newScale = parseFloat(exploreZoomControllerInput.value);
        const oldLeft = exploreField.leftPos;
        const oldTop = exploreField.topPos;
        const offsetLeft = (oldLeft + exploreFieldWrapper.offsetWidth / 2 - exploreField.offsetWidth / 2 * (1 - oldScale)) / oldScale;
        const offsetTop = (oldTop + exploreFieldWrapper.offsetHeight / 2 - exploreField.offsetHeight / 2 * (1 - oldScale)) / oldScale;
        const newLeft = oldLeft - (offsetLeft - exploreField.offsetWidth / 2) * (oldScale - newScale);
        const newTop = oldTop - (offsetTop - exploreField.offsetHeight / 2) * (oldScale - newScale);
        exploreField.scaleExploreField(newScale);
        if (newScale >= minZoomValue && newScale <= maxZoomValue) exploreField.moveExploreFieldTo(newLeft, newTop);
    });
    exploreFieldWrapper.zoomController = exploreZoomControllerInput;
    exploreField.zoomController = exploreZoomControllerInput;
    exploreFieldWrapper.append(exploreZoomController);
}

});


parcelRegister("aaNRX", function(module, exports) {

$parcel$export(module.exports, "makeElementRepostButton", () => $7681858a84ba6e0e$export$f174c688d41d81c4);

var $fKjmJ = parcelRequire("fKjmJ");

var $9VVEN = parcelRequire("9VVEN");

var $31Bjw = parcelRequire("31Bjw");

var $7NPUP = parcelRequire("7NPUP");

var $81Clf = parcelRequire("81Clf");

var $jFzoB = parcelRequire("jFzoB");

var $cCBwI = parcelRequire("cCBwI");
parcelRequire("5zOzO");

var $lz1lC = parcelRequire("lz1lC");
const $7681858a84ba6e0e$var$MAX_REPOST_LENGTH = 10000;
function $7681858a84ba6e0e$export$f174c688d41d81c4(element, nodeId) {
    element.addEventListener('click', ()=>$7681858a84ba6e0e$var$invokeRepostWindow(nodeId));
    element.makeColorInteractions = (backgroundColor, textColor, backgroundInteraction = null, textInteraction = null)=>$7681858a84ba6e0e$var$makeColorInteractions(element, backgroundColor, textColor, backgroundInteraction, textInteraction);
    return element;
}
function $7681858a84ba6e0e$var$invokeRepostWindow(nodeId) {
    const plaque = (0, $fKjmJ.createPlaque)();
    plaque.style.paddingTop = '140px';
    const createRepostWindow = document.createElement('div');
    createRepostWindow.setAttribute('id', 'create-repost-window');
    //const createRepostLabel = document.createElement('p');
    //createRepostLabel.innerText = 'Add a commentary to your repost'
    const createRepostText = document.createElement('textarea');
    createRepostText.placeholder = 'Add a commentary to your repost...';
    const repostButtonGroup = $7681858a84ba6e0e$var$createRepostButtonGroup(nodeId, createRepostText, plaque);
    //createRepostWindow.append(createRepostLabel);
    createRepostWindow.append(createRepostText);
    createRepostWindow.append(repostButtonGroup);
    plaque.append(createRepostWindow);
}
function $7681858a84ba6e0e$var$createRepostButtonGroup(nodeId, textInput, plaque) {
    const repostButtonGroup = document.createElement('div');
    const createRepostButton = document.createElement('button');
    const cancelRepost = document.createElement('button');
    (0, $81Clf.makeNewButton)(createRepostButton, 'light-black', 'white', 'Repost', 'lighten');
    createRepostButton.addEventListener('click', ()=>$7681858a84ba6e0e$var$sendRepost(nodeId, textInput, plaque, repostButtonGroup));
    (0, $81Clf.makeNewButton)(cancelRepost, 'grey', 'black', 'Cancel', 'darken');
    cancelRepost.addEventListener('click', ()=>(0, $9VVEN.quitPlaque)(plaque, 'Are you sure you don\'t want to repost?', 'Go back', 'Quit'));
    (0, $31Bjw.makePlaqueQuitToggle)(plaque, 'Are you sure you don\'t want to repost?', 'Go back', 'Quit');
    repostButtonGroup.append(cancelRepost);
    repostButtonGroup.append(createRepostButton);
    return repostButtonGroup;
}
async function $7681858a84ba6e0e$var$sendRepost(nodeId, textInput, plaque, buttonGroup) {
    const commentary = (0, $lz1lC.ParamValidator).basicSanitize(textInput.value);
    if (!(0, $lz1lC.ParamValidator).isSafeTextNullable(commentary, $7681858a84ba6e0e$var$MAX_REPOST_LENGTH)) {
        (0, $cCBwI.insertPlaqueAndAlertWindow)('Your repost commentary is either too long or contains inappropriate characters');
        return;
    }
    const loadingScreen = (0, $jFzoB.createLoadingScreen)(50, 50, 100);
    buttonGroup.insertAdjacentElement('beforebegin', loadingScreen);
    buttonGroup.remove();
    const url = new URL((0, $7NPUP.API_GATEWAY) + 'posts/repost'); // <--- change
    url.searchParams.append('nodeId', nodeId);
    url.searchParams.append('commentary', commentary);
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Token-Auth': `${localStorage.branchof_access_token}`
        }
    });
    setTimeout(()=>{
        if (response.status === 200) plaque.remove();
        else if (response.status === 401) {
            const newButtonGroup = $7681858a84ba6e0e$var$createRepostButtonGroup(nodeId, textInput, plaque);
            loadingScreen.insertAdjacentElement('beforebegin', newButtonGroup);
            loadingScreen.remove();
            (0, $cCBwI.insertPlaqueAndAlertWindow)('Your login has expired');
        //logOutWithTimeOut();
        } else {
            const newButtonGroup = $7681858a84ba6e0e$var$createRepostButtonGroup(nodeId, textInput, plaque);
            loadingScreen.insertAdjacentElement('beforebegin', newButtonGroup);
            loadingScreen.remove();
            (0, $cCBwI.insertPlaqueAndAlertWindow)('Something went wrong');
        }
    }, 1000);
}
function $7681858a84ba6e0e$var$makeColorInteractions(repostButton, backgroundColor, textColor, backgroundInteraction, textInteraction) {
    (0, $81Clf.makeNewButton)(repostButton, backgroundColor, textColor, null, backgroundInteraction, textInteraction);
}

});

parcelRegister("a5iko", function(module, exports) {

$parcel$export(module.exports, "default", () => $757896920385cac5$export$2e2bcd8739ae039);
parcelRequire("7NPUP");

var $9VVEN = parcelRequire("9VVEN");

var $31Bjw = parcelRequire("31Bjw");

var $jFzoB = parcelRequire("jFzoB");

var $cCBwI = parcelRequire("cCBwI");

var $5zOzO = parcelRequire("5zOzO");

var $iqZMU = parcelRequire("iqZMU");

var $f02AW = parcelRequire("f02AW");

var $81Clf = parcelRequire("81Clf");

var $1iaFb = parcelRequire("1iaFb");

var $49k2f = parcelRequire("49k2f");

var $lz1lC = parcelRequire("lz1lC");

var $ha4AH = parcelRequire("ha4AH");
const $757896920385cac5$var$mainBodyElement = document.querySelector('body');
const $757896920385cac5$var$listOfTypes = [
    'Link to a SoundCloud audio',
    'Link to a Youtube video',
    'Upload an image',
    //'Upload a PDF file',
    'An idea for a content'
];
const $757896920385cac5$var$listOfTypesFunctionsInit = {
    'Link to a SoundCloud audio': $757896920385cac5$var$soundCloudContentInsertInitialize,
    'Link to a Youtube video': $757896920385cac5$var$youTubeContentInsertInitialize,
    //'Upload a PDF file' : pdfContentUploadInitialize,
    'Upload an image': $757896920385cac5$var$imageContentUploadInitialize
};
const $757896920385cac5$var$listOfTypesReadProperties = {
    'Link to a Youtube video': 'YT_URL',
    'Link to a SoundCloud audio': 'SCL_URL',
    'Upload an image': 'PIC_FILE',
    //'Upload a PDF file' : {method : 'upload', prefix : 'pdf-file '},
    //'Upload a PDF file' : PDF_FILE,
    'An idea for a content': 'IDEA'
};
function $757896920385cac5$export$2e2bcd8739ae039(parentId = null) {
    const plaque = document.createElement('div');
    plaque.setAttribute('id', 'plaque');
    $757896920385cac5$var$mainBodyElement.append(plaque);
    const node_window = document.createElement('div');
    node_window.setAttribute('id', 'create-node-window');
    plaque.append(node_window);
    //-----------------------Select type section--------------------------
    const selectTypeSection = document.createElement('div');
    const selectButton = document.createElement('select');
    const chooseType = document.createElement('option');
    chooseType.innerText = 'Choose the type of preview';
    selectButton.append(chooseType);
    for (let i of $757896920385cac5$var$listOfTypes){
        const typeOption = document.createElement('option');
        typeOption.innerText = i;
        selectButton.append(typeOption);
    }
    selectButton.addEventListener('change', (e)=>$757896920385cac5$var$selectTypeChange(e));
    selectTypeSection.append(selectButton);
    selectTypeSection.setAttribute('id', 'select-type-section');
    node_window.append(selectTypeSection);
    //-------------------------Name of the content-------------------------
    const nameSection = document.createElement('div');
    const nameInput = document.createElement('textarea');
    nameInput.placeholder = 'Name of your content';
    nameInput.maxLength = 100;
    nameInput.addEventListener('input', (e)=>$757896920385cac5$var$textAreaContentReszie(e));
    nameSection.append(nameInput);
    nameSection.setAttribute('id', 'name-section');
    node_window.append(nameSection);
    //-------------------------Resources insertion-------------------------
    const resourcesSection = document.createElement('div');
    const resourcesTitle = document.createElement('p');
    const resourceLinksGroup = document.createElement('div');
    $757896920385cac5$var$createNewLink(resourceLinksGroup);
    resourcesTitle.innerText = 'Links to resources:';
    resourceLinksGroup.setAttribute('id', 'resource-links-group');
    resourcesSection.append(resourcesTitle);
    resourcesSection.append(resourceLinksGroup);
    resourcesSection.setAttribute('id', 'resource-section');
    node_window.append(resourcesSection);
    //-------------------------Description---------------------------------
    const descriptionSection = document.createElement('div');
    const descriptionBody = document.createElement('textarea');
    descriptionBody.placeholder = 'Add a description...';
    descriptionBody.maxLength = 65535;
    descriptionBody.addEventListener('input', (e)=>$757896920385cac5$var$textAreaContentReszie(e));
    descriptionSection.append(descriptionBody);
    descriptionSection.setAttribute('id', 'description-section');
    node_window.append(descriptionSection);
    //-------------------------Tags----------------------------------------
    const tagsSection = document.createElement('div');
    const tagsInput = document.createElement('input');
    tagsInput.setAttribute('id', 'tags-input');
    tagsInput.placeholder = 'Add a tag...';
    tagsInput.addEventListener('keypress', (e)=>$757896920385cac5$var$tagsInputKey(e));
    tagsSection.append(tagsInput);
    tagsSection.setAttribute('id', 'tags-section');
    node_window.append(tagsSection);
    //-------------------------Anonymous warning----------------------------
    const loginToken = localStorage.getItem("branchof_access_token");
    if (loginToken === null || loginToken === undefined) {
        const anonymousWarning = (0, $iqZMU.createElement)('p', "create-node-anonymous-warning", null);
        anonymousWarning.innerText = "Remember: You are creating this branch anonymously. You will be given a reclaim token that you can use to reclaim authorship of this branch later, when you become a registered user. Until then, the author for this branch will be listed as anonymous.";
        node_window.append(anonymousWarning);
    }
    //-------------------------Buttons--------------------------------------
    const buttonSection = document.createElement('div');
    const cancelButton = document.createElement('button');
    const publishButton = document.createElement('button');
    cancelButton.innerText = 'Quit';
    publishButton.innerText = 'Publish the branch';
    publishButton.addEventListener('click', ()=>$757896920385cac5$var$publish(plaque, parentId, buttonSection, node_window));
    buttonSection.append(cancelButton);
    buttonSection.append(publishButton);
    buttonSection.setAttribute('id', 'buttons-section');
    node_window.append(buttonSection);
    (0, $31Bjw.makePlaqueQuitToggle)(plaque, 'Are you sure you want to quit branching?', 'Go back', 'Quit');
    cancelButton.addEventListener('click', ()=>(0, $9VVEN.quitPlaque)(plaque, 'Are you sure you want to quit branching?', 'Go back', 'Quit'));
}
function $757896920385cac5$var$plaquePress(e) {
    if (e.target.id === 'plaque') document.getElementById('plaque').remove();
}
function $757896920385cac5$var$textAreaContentReszie(e) {
    const textarea = e.target;
    // Create a hidden div element if it doesn’t already exist
    let hiddenDiv = textarea._hiddenDiv;
    if (!hiddenDiv) {
        hiddenDiv = document.createElement('div');
        hiddenDiv.style.position = 'absolute';
        hiddenDiv.style.visibility = 'hidden';
        hiddenDiv.style.whiteSpace = 'pre-wrap';
        hiddenDiv.style.wordWrap = 'break-word';
        hiddenDiv.style.boxSizing = 'border-box';
        hiddenDiv.style.padding = '0'; // Remove padding for accurate height calculation
        hiddenDiv.style.border = 'none'; // Exclude borders in height calculation
        textarea._hiddenDiv = hiddenDiv; // Attach it to the textarea for reuse
        hiddenDiv.style.left = 0;
        hiddenDiv.style.top = 0;
        document.getElementById('plaque').append(hiddenDiv);
    }
    // Mirror textarea styles to the hidden div
    const computedStyle = window.getComputedStyle(textarea);
    hiddenDiv.style.width = computedStyle.width;
    hiddenDiv.style.font = computedStyle.font;
    hiddenDiv.style.lineHeight = computedStyle.lineHeight;
    hiddenDiv.style.padding = 0;
    // Set the content of the hidden div to match the textarea
    hiddenDiv.textContent = textarea.value || textarea.placeholder || ' ';
    // Calculate the new height
    const singleLineHeight = parseInt(computedStyle.lineHeight, 10); // Height for one line
    const newHeight = Math.max(hiddenDiv.offsetHeight, singleLineHeight); // Ensure at least one line fits
    // Apply the calculated height to the textarea
    textarea.style.height = `${newHeight}px`;
}
//--------------Type of content functions-----------------------------------------------------------------------
function $757896920385cac5$var$selectTypeChange(e) {
    const selectElement = e.target;
    $757896920385cac5$var$deleteContentInsertionSection();
    const contentInsertInitialize = $757896920385cac5$var$listOfTypesFunctionsInit[selectElement.value];
    console.log(contentInsertInitialize, $757896920385cac5$var$listOfTypesFunctionsInit[selectElement.value]);
    if (contentInsertInitialize !== null && contentInsertInitialize !== undefined) contentInsertInitialize();
}
function $757896920385cac5$var$deleteContentInsertionSection() {
    const contentInsertSection = document.getElementById('content-preview-section');
    if (contentInsertSection !== null) contentInsertSection.remove();
}
function $757896920385cac5$var$createInsertUrl(placeholder, previewFunction) {
    const contentInsertInput = document.createElement('input');
    contentInsertInput.setAttribute('id', 'content-insert-url');
    contentInsertInput.placeholder = placeholder;
    contentInsertInput.addEventListener('change', (e)=>previewFunction(e));
    return contentInsertInput;
}
function $757896920385cac5$var$createUploadFileLabelAndInput(labelText, previewFunction) {
    const contentUploadLabel = document.createElement('label');
    contentUploadLabel.innerText = labelText;
    contentUploadLabel.setAttribute('for', 'content-upload-file-input');
    const contentUploadInput = document.createElement('input');
    contentUploadInput.setAttribute('type', 'file');
    contentUploadInput.setAttribute('id', 'content-upload-file-input');
    contentUploadInput.setAttribute('name', 'content-upload-file-input');
    const contentGroupDiv = document.createElement('div');
    contentGroupDiv.append(contentUploadLabel);
    contentGroupDiv.append(contentUploadInput);
    contentGroupDiv.setAttribute('id', 'content-upload-file');
    contentUploadInput.addEventListener('change', (e)=>{
        previewFunction(e.target.files[0]);
    });
    return {
        label: contentUploadLabel,
        input: contentUploadInput,
        group: contentGroupDiv
    };
}
function $757896920385cac5$var$soundCloudContentInsertInitialize() {
    const contentInsertSection = document.createElement('div');
    const contentInsertInput = $757896920385cac5$var$createInsertUrl('Add a link to your SoundCloud audio', $757896920385cac5$var$soundCloudContentUrlPreview);
    // const contentInsertMethod = document.createElement('select'); //in case there are multiple methods
    contentInsertSection.append(contentInsertInput);
    contentInsertSection.setAttribute('id', 'content-preview-section');
    document.getElementById('select-type-section').insertAdjacentElement('afterend', contentInsertSection);
}
async function $757896920385cac5$var$soundCloudContentUrlPreview(e) {
    const contentInsertInput = e.target;
    const soundCloudUrl = contentInsertInput.value;
    const response = await fetch('https://soundcloud.com/oembed?url=' + soundCloudUrl, {
        method: 'GET',
        headers: {
            'Accept': 'application/json'
        }
    });
    if (response.status == 200) {
        const data = await response.json();
        const oldPreviewBlock = document.querySelector('#content-preview-soundcloud > iframe');
        const htmlCode = document.createElement('div');
        htmlCode.innerHTML = data.html;
        if (oldPreviewBlock !== null) oldPreviewBlock.src = htmlCode.querySelector('iframe').src;
        else {
            const previewBlock = document.createElement('div');
            const previewContent = document.createElement('iframe');
            previewContent.src = htmlCode.querySelector('iframe').src;
            previewBlock.append(previewContent);
            previewBlock.setAttribute('id', 'content-preview-soundcloud');
            document.getElementById('content-insert-url').insertAdjacentElement('beforebegin', previewBlock);
        }
    }
}
function $757896920385cac5$var$youTubeContentInsertInitialize() {
    const contentInsertSection = document.createElement('div');
    const contentInsertInput = $757896920385cac5$var$createInsertUrl('Add a link to your YouTube video', $757896920385cac5$var$youTubeContentUrlPreview);
    // const contentInsertMethod = document.createElement('select'); //in case there are multiple methods
    contentInsertSection.append(contentInsertInput);
    contentInsertSection.setAttribute('id', 'content-preview-section');
    document.getElementById('select-type-section').insertAdjacentElement('afterend', contentInsertSection);
}
async function $757896920385cac5$var$youTubeContentUrlPreview(e) {
    const contentInsertInput = e.target;
    const youtubeUrl = contentInsertInput.value;
    const response = await fetch('https://youtube.com/oembed?url=' + youtubeUrl, {
        method: 'GET',
        headers: {
            'Accept': 'application/json'
        }
    });
    if (response.status == 200) {
        const data = await response.json();
        const oldPreviewBlock = document.querySelector('#content-preview-youtube > iframe');
        const htmlCode = document.createElement('div');
        htmlCode.innerHTML = data.html;
        if (oldPreviewBlock !== null) oldPreviewBlock.src = htmlCode.querySelector('iframe').src;
        else {
            const previewBlock = document.createElement('div');
            const previewContent = document.createElement('iframe');
            previewContent.src = htmlCode.querySelector('iframe').src;
            previewBlock.append(previewContent);
            previewBlock.setAttribute('id', 'content-preview-youtube');
            document.getElementById('content-insert-url').insertAdjacentElement('beforebegin', previewBlock);
        }
    }
}
function $757896920385cac5$var$imageContentUploadInitialize() {
    const contentUploadSection = document.createElement('div');
    const contentUploadLabelAndInput = $757896920385cac5$var$createUploadFileLabelAndInput('Choose an image', $757896920385cac5$var$imageContentUploadPreview);
    const contentUploadLabel = contentUploadLabelAndInput.label;
    const contentUploadInput = contentUploadLabelAndInput.input;
    const contentGroupDiv = contentUploadLabelAndInput.group;
    // const contentInsertMethod = document.createElement('select'); //in case there are multiple methods
    contentUploadInput.setAttribute('accept', '.jpg, .jpeg, .png, .gif');
    contentUploadSection.append(contentGroupDiv);
    contentUploadSection.setAttribute('id', 'content-preview-section');
    document.getElementById('select-type-section').insertAdjacentElement('afterend', contentUploadSection);
}
function $757896920385cac5$var$imageContentUploadPreview(imageFile) {
    const oldPreviewImage = document.querySelector('#content-preview-image-upload > img');
    if (oldPreviewImage !== null) oldPreviewImage.src = URL.createObjectURL(imageFile);
    else {
        const previewBlock = document.createElement('div');
        const previewImage = document.createElement('img');
        previewImage.src = URL.createObjectURL(imageFile);
        previewBlock.append(previewImage);
        previewBlock.setAttribute('id', 'content-preview-image-upload');
        document.getElementById('content-upload-file').insertAdjacentElement('beforebegin', previewBlock);
    }
}
function $757896920385cac5$var$pdfContentUploadInitialize() {
    const contentUploadSection = document.createElement('div');
    const contentUploadLabelAndInput = $757896920385cac5$var$createUploadFileLabelAndInput('Choose a PDF file', $757896920385cac5$var$pdfContentUploadPreview);
    const contentUploadLabel = contentUploadLabelAndInput.label;
    const contentUploadInput = contentUploadLabelAndInput.input;
    const contentGroupDiv = contentUploadLabelAndInput.group;
    // const contentInsertMethod = document.createElement('select'); //in case there are multiple methods
    contentUploadInput.setAttribute('accept', '.pdf');
    contentUploadSection.append(contentGroupDiv);
    contentUploadSection.setAttribute('id', 'content-preview-section');
    document.getElementById('select-type-section').insertAdjacentElement('afterend', contentUploadSection);
}
function $757896920385cac5$var$pdfContentUploadPreview(pdfFile) {
    const oldPreviewPdf = document.querySelector('#content-preview-pdf-upload > embed');
    if (oldPreviewPdf !== null) oldPreviewPdf.src = URL.createObjectURL(pdfFile);
    else {
        const previewBlock = document.createElement('div');
        const previewPdf = document.createElement('embed');
        previewPdf.src = URL.createObjectURL(pdfFile);
        previewBlock.append(previewPdf);
        previewBlock.setAttribute('id', 'content-preview-pdf-upload');
        document.getElementById('content-upload-file').insertAdjacentElement('beforebegin', previewBlock);
    }
}
//--------------Resources functions-----------------------------------------------------------------------------
function $757896920385cac5$var$linkInputChangeFinal(e) {
    const link = e.target.parentElement;
    const linkGroup = link.parentElement;
    const linkComment = link.querySelector('.create-resource-link > :last-child');
    const valuesPresent = $757896920385cac5$var$linkAndCommentValuesPresent(link);
    const nextValuesPresent = $757896920385cac5$var$nextLinkValuesPresent(link);
    console.log(valuesPresent, nextValuesPresent);
    if (!valuesPresent && link.nextSibling !== null) link.remove();
}
function $757896920385cac5$var$linkInputChange(e) {
    const link = e.target.parentElement;
    const linkGroup = link.parentElement;
    const linkComment = link.querySelector('.create-resource-link > :last-child');
    const valuesPresent = $757896920385cac5$var$linkAndCommentValuesPresent(link);
    const nextValuesPresent = $757896920385cac5$var$nextLinkValuesPresent(link);
    console.log(valuesPresent, nextValuesPresent);
    if (valuesPresent) {
        linkComment.classList.remove('hidden-info');
        if (link.nextSibling === null) $757896920385cac5$var$createNewLink(linkGroup);
    } else if (!valuesPresent) {
        linkComment.classList.add('hidden-info');
        if (!nextValuesPresent) {
            link.nextSibling.remove();
            console.log('next removed!');
        }
    }
}
function $757896920385cac5$var$createNewLink(linkGroup) {
    const resourceLink = document.createElement('div');
    const resourceLinkInput = document.createElement('input');
    const resourceLinkComment = document.createElement('input');
    resourceLinkInput.placeholder = 'add a link';
    resourceLinkInput.addEventListener('input', (e)=>$757896920385cac5$var$linkInputChange(e));
    resourceLinkInput.addEventListener('change', (e)=>$757896920385cac5$var$linkInputChangeFinal(e));
    resourceLinkComment.placeholder = 'commentary...';
    resourceLinkComment.addEventListener('input', (e)=>$757896920385cac5$var$linkInputChange(e));
    resourceLinkComment.addEventListener('change', (e)=>$757896920385cac5$var$linkInputChangeFinal(e));
    resourceLinkComment.classList.add('hidden-info');
    resourceLink.append(resourceLinkInput);
    resourceLink.append(resourceLinkComment);
    resourceLink.classList.add('create-resource-link');
    linkGroup.append(resourceLink);
}
function $757896920385cac5$var$linkAndCommentValuesPresent(link) {
    const linkInputs = link.querySelectorAll('input');
    for (let i of linkInputs){
        if (i.value !== '') return true;
    }
    return false;
}
function $757896920385cac5$var$nextLinkValuesPresent(link) {
    if (link.nextSibling !== null) return $757896920385cac5$var$linkAndCommentValuesPresent(link.nextSibling);
}
//--------------Tags functions-----------------------------------------------------------------------------
function $757896920385cac5$var$tagsInputKey(e) {
    const tagsInput = e.target;
    const tagsSection = tagsInput.parentElement;
    const key = e.key;
    if (key === 'Enter' || key === ',') {
        e.preventDefault();
        tagsInput.insertAdjacentElement('beforebegin', $757896920385cac5$var$createTag(tagsInput.value));
        tagsInput.value = '';
    }
}
function $757896920385cac5$var$createTag(tagName) {
    const newTag = document.createElement('div');
    newTag.classList.add('tag');
    const tagLabel = document.createElement('p');
    tagLabel.innerText = tagName;
    newTag.append(tagLabel);
    return newTag;
}
//--------------Buttons functions-----------------------------------------------------------------------------
async function $757896920385cac5$var$publish(plaque, parentId, buttonSection, createWindow) {
    const request = (0, $f02AW.createRequestObject)();
    request.setMethod('POST');
    const node_window = plaque.querySelector('#create-node-window');
    const loadingScreen = (0, $jFzoB.createLoadingScreen)(50, 50, 100);
    createWindow.append(loadingScreen);
    buttonSection.classList.add('hidden-info');
    const onResponseStatus4xxFunction = async (response)=>{
        const message = await response.text();
        loadingScreen.remove();
        buttonSection.classList.remove('hidden-info');
        if (message) (0, $cCBwI.insertPlaqueAndAlertWindow)(message);
        else (0, $cCBwI.insertPlaqueAndAlertWindow)('Something went wrong!');
    };
    const somethingWentWrong = ()=>{
        loadingScreen.remove();
        buttonSection.classList.remove('hidden-info');
        (0, $cCBwI.insertPlaqueAndAlertWindow)('Something went wrong!');
    };
    const previewCreationMethod = $757896920385cac5$var$previewMethodRead(node_window);
    if (!previewCreationMethod) {
        const previewTypeCircle = (0, $ha4AH.createPreviewTypeCircle)(plaque);
        loadingScreen.remove();
        buttonSection.classList.remove('hidden-info');
        (0, $cCBwI.insertPlaqueAndAlertWindow)('Choose a type for your preview!');
        return null;
    }
    const nodeName = $757896920385cac5$var$readName(node_window);
    const resources = $757896920385cac5$var$readResources(node_window);
    const description = $757896920385cac5$var$readDescription(node_window);
    const tags = $757896920385cac5$var$readTags(node_window);
    if (nodeName === null || nodeName.length < 1) {
        loadingScreen.remove();
        buttonSection.classList.remove('hidden-info');
        (0, $cCBwI.insertPlaqueAndAlertWindow)('Your branch needs to have a name!');
        return null;
    }
    let urlString = "/branches/submit";
    //Auth vs Anon definition
    const loginToken = localStorage.getItem("branchof_access_token");
    if (loginToken !== null && loginToken !== undefined) {
        urlString = urlString + "";
        request.addHeader('Token-Auth', `${localStorage.branchof_access_token}`);
        request.onResponseStatus('200', async (response)=>{
            (0, $cCBwI.insertPlaqueAndAlertWindow)('You have branched successfully! Yay! :D');
            plaque.remove();
        });
    } else {
        urlString = urlString + "/anonymous";
        const anonToken = localStorage.getItem("branchof_anon_token");
        if (anonToken !== null && anonToken !== undefined) request.addHeader('Token-Anon', anonToken);
        //The default behavior (new anon-token is issued)
        request.onResponseStatus('201', async (response)=>{
            const reclaimToken = await response.text();
            $757896920385cac5$var$insertPlaqueAndAlertWindowAndReclaimToken(reclaimToken);
            localStorage.setItem("branchof_anon_token", reclaimToken);
            plaque.remove();
        });
        //The irregular behavior (a pre-existing is used)
        request.onResponseStatus('200', async (response)=>{
            const reclaimToken = await response.text();
            $757896920385cac5$var$insertPlaqueAndAlertWindowAndReclaimToken(reclaimToken, true);
            plaque.remove();
        });
    }
    request.setURL(urlString);
    const newNode = {};
    newNode.name = nodeName;
    if (resources !== null) newNode.resources = resources;
    if (description !== null) newNode.description = description;
    if (tags !== null) newNode.tags = tags;
    if (parentId !== null) request.addSearchParam('parentId', parentId);
    const previewCreationInjections = {};
    previewCreationInjections.onResponseStatus4xxFunction = onResponseStatus4xxFunction;
    previewCreationInjections.somethingWentWrong = somethingWentWrong;
    previewCreationInjections.loadingScreen = loadingScreen;
    previewCreationInjections.buttonSection = buttonSection;
    console.log("newNode ", newNode);
    console.log("request ", request);
    request.onResponseStatus('204', ()=>{
        loadingScreen.remove();
        buttonSection.classList.remove('hidden-info');
        (0, $cCBwI.insertPlaqueAndAlertWindow)('This parent branch doesn\'t exist');
    });
    request.onResponseStatus('417', ()=>{
        loadingScreen.remove();
        buttonSection.classList.remove('hidden-info');
        (0, $cCBwI.insertPlaqueAndAlertWindow)('We couldn\'t create your Branch. Try again later, please.');
    });
    request.onResponseStatus('401', ()=>{
        loadingScreen.remove();
        buttonSection.classList.remove('hidden-info');
        plaque.classList.add('hidden-info');
        localStorage.removeItem('branchof_access_token');
        localStorage.removeItem('branchof_access_username');
        $757896920385cac5$var$insertPlaqueAndAlertSwitchingToAnon(plaque, parentId, buttonSection, createWindow);
    });
    request.onResponseStatus4xx(onResponseStatus4xxFunction);
    request.onResponseElse(somethingWentWrong);
    const contentPreviewSection = node_window.querySelector('#content-preview-section');
    const previewCreationPromise = (0, $1iaFb.createPreviewPromise)(previewCreationMethod, contentPreviewSection, previewCreationInjections);
    previewCreationPromise.then((preview)=>{
        newNode.preview = preview;
        try {
            const sanitizedBranch = (0, $49k2f.isValidBranch)(newNode);
            request.setBodyJsonFromObject(sanitizedBranch);
            request.executeRequest();
        } catch (e) {
            if (e instanceof (0, $lz1lC.ValidationError)) {
                loadingScreen.remove();
                buttonSection.classList.remove('hidden-info');
                (0, $cCBwI.insertPlaqueAndAlertWindow)(e.message);
            } else {
                console.log("Error: ", e);
                throw e;
            }
        }
    }).catch((error)=>{
        loadingScreen.remove();
        buttonSection.classList.remove('hidden-info');
        (0, $cCBwI.insertPlaqueAndAlertWindow)(error.message);
        console.log(error);
        return;
    });
}
function $757896920385cac5$var$insertPlaqueAndAlertWindowAndReclaimToken(reclaimToken, tokenReused = false) {
    const plaqueAndAlert = (0, $cCBwI.insertPlaqueAndAlertWindow)("You have branched anonymously");
    const alertWindow = plaqueAndAlert.alertWindow;
    alertWindow.classList.add('reclaim-token-alert-message');
    const line1 = (0, $iqZMU.createElement)('p', null, null);
    line1.innerText = "Here is your Reclaim Token, so you can reclaim authorship later, once you are registered.";
    const reclaimTokenInput = (0, $iqZMU.createElement)('input', null, null);
    reclaimTokenInput.value = reclaimToken;
    reclaimTokenInput.readOnly = true;
    reclaimTokenInput.addEventListener('click', ()=>{
        reclaimTokenInput.select(); // This selects the entire current value
    });
    const line2 = (0, $iqZMU.createElement)('p', null, null);
    line2.innerText = "Save it, or you will lose access to your new branch.";
    alertWindow.appendToCenter(line1);
    alertWindow.appendToCenter(reclaimTokenInput);
    alertWindow.appendToCenter(line2);
    if (tokenReused === true) {
        line1.innerText = "Your branch has been credited to an already-existing token: ";
        line2.innerText = "This is the token that was used for other branches you created anonymously. Use this token to reclaim multiple branches later on.";
    }
    return plaqueAndAlert;
}
function $757896920385cac5$var$insertPlaqueAndAlertSwitchingToAnon(plaque, parentId, buttonSection, createWindow) {
    const plaqueAndAlert = (0, $cCBwI.insertPlaqueAndAlertWindow)("You have branched anonymously");
    const alertWindow = plaqueAndAlert.alertWindow;
    const alertWindowButton = alertWindow.alertWindowButton;
    alertWindowButton.remove();
    alertWindow.classList.add('switching-to-anon-alert-message');
    const line1 = (0, $iqZMU.createElement)('p', null, null);
    line1.innerText = "Unfortunately, you've been logged out, or your login session has expired.";
    const line2 = (0, $iqZMU.createElement)('p', null, null);
    line2.innerText = "You can re-login, or you can proceed with the Branch creation, but then your Branch will be lsited as an anonymous author's Branch.";
    const line3 = (0, $iqZMU.createElement)('p', null, null);
    line3.innerText = "You will be able to reclaim your anonymous Branch with a special token we will issue for you after the Branch is created.";
    const buttonSectionNew = (0, $iqZMU.createElement)('div', null, [
        'switching-to-anon-alert-button-section'
    ]);
    const reloginButton = (0, $iqZMU.createElement)('button', null, null);
    (0, $81Clf.makeNewButton)(reloginButton, 'light-black', 'white', 'Log in again', 'lighten');
    reloginButton.addEventListener('click', ()=>{
        (0, $5zOzO.logOut)();
    });
    const anonButton = (0, $iqZMU.createElement)('button', null, null);
    (0, $81Clf.makeNewButton)(anonButton, 'grey', 'black', 'Publish Anonymously', 'darken');
    anonButton.addEventListener('click', ()=>{
        createWindow.classList.remove('hidden-info');
        plaqueAndAlert.remove();
        $757896920385cac5$var$publish(plaque, parentId, buttonSection, createWindow);
    });
    buttonSectionNew.append(reloginButton, anonButton);
    alertWindow.appendToCenter(line1);
    alertWindow.appendToCenter(line2);
    alertWindow.appendToCenter(line3);
    alertWindow.appendToCenter(buttonSectionNew);
    return plaqueAndAlert;
}
function $757896920385cac5$var$previewMethodRead(node_window) {
    const select = node_window.querySelector('#select-type-section > select');
    const previewMethod = $757896920385cac5$var$listOfTypesReadProperties[select.value];
    return previewMethod;
}
function $757896920385cac5$var$readName(node_window) {
    return node_window.querySelector('#name-section > textarea').value;
}
function $757896920385cac5$var$readResources(node_window) {
    const resources = node_window.querySelectorAll('.create-resource-link');
    const resourceArray = [];
    for (let resource of resources){
        const resourceObject = {
            link: resource.querySelector(':first-child').value,
            commentary: resource.querySelector(':last-child').value
        };
        if (resourceObject.link !== '') resourceArray.push(resourceObject);
    }
    if (resourceArray.length === 0) return null;
    return resourceArray;
}
function $757896920385cac5$var$checkResource(resource) {
    if (resource.querySelector(':first-child').value !== '') return true;
}
function $757896920385cac5$var$readDescription(node_window) {
    const description = node_window.querySelector('#description-section > textarea');
    if (description.value === null || description.value.length === 0) return null;
    return description.value;
}
function $757896920385cac5$var$readTags(node_window) {
    const tags = node_window.querySelectorAll('.tag > p');
    const tagsArray = [];
    for (let tag of tags)tagsArray.push(tag.innerText);
    if (tagsArray.length === 0) return null;
    return tagsArray;
}

});
parcelRegister("1iaFb", function(module, exports) {

$parcel$export(module.exports, "createPreviewPromise", () => $0f0fbe645891c118$export$31a761528a17d84a);

var $cCBwI = parcelRequire("cCBwI");

var $7NPUP = parcelRequire("7NPUP");

var $3nR07 = parcelRequire("3nR07");

var $f02AW = parcelRequire("f02AW");
const $0f0fbe645891c118$var$methodReadValues = {
    'YT_URL': $0f0fbe645891c118$var$youtubePreviewCreate,
    'SCL_URL': $0f0fbe645891c118$var$soundcloudPreviewCreate,
    'PIC_FILE': $0f0fbe645891c118$var$picFilePreviewCreate,
    'IDEA': $0f0fbe645891c118$var$ideaPreviewCreate
};
function $0f0fbe645891c118$export$31a761528a17d84a(previewMethod, contentPreviewSection, injectionsObject) {
    console.log("previewMethod " + previewMethod);
    const previewPromiseFunction = $0f0fbe645891c118$var$methodReadValues[previewMethod];
    if (previewPromiseFunction instanceof Function) return previewPromiseFunction(contentPreviewSection, injectionsObject);
    else return Promise.reject(new Error("Invalid preview creation method."));
}
function $0f0fbe645891c118$var$youtubePreviewCreate(contentPreviewSection) {
    const url = contentPreviewSection.querySelector('iframe').src;
    const videoId = url.replace("https://www.youtube.com/embed/", "").replace("?feature=oembed", "");
    const preview = {
        method: 'YT_URL',
        videoId: videoId
    };
    return Promise.resolve(preview);
}
function $0f0fbe645891c118$var$soundcloudPreviewCreate(contentPreviewSection) {
    const url = contentPreviewSection.querySelector('iframe').src;
    // Extract the encoded "url" parameter
    const params = new URLSearchParams(url.split('?')[1]);
    const encodedTrackUrl = params.get('url'); // e.g. "https%3A%2F%2Fapi.soundcloud.com%2Ftracks%2F1946207687"
    if (!encodedTrackUrl) throw new Error("Invalid SoundCloud embed URL \u2014 missing track parameter.");
    // Decode the parameter
    const decodedTrackUrl = decodeURIComponent(encodedTrackUrl); // e.g. "https://api.soundcloud.com/tracks/1946207687"
    // Extract just the track ID
    const trackId = decodedTrackUrl.split('/').pop(); // "1946207687"
    const preview = {
        method: 'SCL_URL',
        trackId: trackId
    };
    return Promise.resolve(preview);
}
function $0f0fbe645891c118$var$picFilePreviewCreate(contentPreviewSection, injectionsObject) {
    let outerResolvePromise;
    let outerRejectPromise;
    const previewPromise = new Promise((resolve, reject)=>{
        outerResolvePromise = resolve;
        outerRejectPromise = reject;
    });
    const file = contentPreviewSection.querySelector('input').files[0];
    const onResponseStatus4xxFunction = ()=>{
        injectionsObject.onResponseStatus4xxFunction;
        outerRejectPromise(new Error('Promise rejected while doing a file upload.'));
    };
    const somethingWentWrong = ()=>{
        injectionsObject.somethingWentWrong;
        outerRejectPromise(new Error('Promise rejected while doing a file upload.'));
    };
    const loadingScreen = injectionsObject.loadingScreen;
    const buttonSection = injectionsObject.buttonSection;
    const uploadTokenRequest = (0, $f02AW.createRequestObject)();
    uploadTokenRequest.setMethod('POST');
    uploadTokenRequest.setURL('/branches/submit/upload/get-token');
    const fileChecker = (0, $3nR07.createFileChecker)();
    fileChecker.setFilePurpose('branch_picture');
    fileChecker.setUniversalStatus((message)=>{
        loadingScreen.remove();
        buttonSection.classList.remove('hidden-info');
        (0, $cCBwI.insertPlaqueAndAlertWindow)(message);
        outerRejectPromise(new Error('Promise rejected while doing a file upload.'));
    });
    const fileValid = fileChecker.checkFile(file);
    if (fileValid === false) return;
    const uploadFielRequest = (0, $f02AW.createRequestObject)();
    uploadFielRequest.setRootURL((0, $7NPUP.API_UPLOAD_URL));
    uploadFielRequest.setURL('/branches/picture');
    uploadFielRequest.setMethod('POST');
    const formData = new FormData();
    formData.append('file', file);
    uploadFielRequest.setBodyFormData(formData);
    uploadTokenRequest.onResponseStatus('200', async (response)=>{
        const uploadToken = await response.text();
        console.log("uploadToken ", uploadToken);
        return uploadToken;
    });
    uploadTokenRequest.onResponseStatus4xx(onResponseStatus4xxFunction);
    uploadTokenRequest.onResponseElse(somethingWentWrong);
    uploadFielRequest.onResponseStatus('200', async (response)=>{
        const key = response.text();
        return key;
    });
    uploadFielRequest.onResponseStatus4xx(onResponseStatus4xxFunction);
    uploadFielRequest.onResponseError(()=>{
        loadingScreen.remove();
        buttonSection.classList.remove('hidden-info');
        (0, $cCBwI.insertPlaqueAndAlertWindow)('We see what you\'re trying to do here.');
        outerRejectPromise(new Error('We see what you\'re trying to do here.'));
    });
    uploadFielRequest.onResponseElse(async (response)=>{
        loadingScreen.remove();
        buttonSection.classList.remove('hidden-info');
        (0, $cCBwI.insertPlaqueAndAlertWindow)('An error occured.');
        const errorText = await response.text();
        console.log("uploadFielRequest error ", errorText);
        outerRejectPromise(new Error(errorText));
    });
    uploadTokenRequest.executeRequest().then((uploadToken)=>{
        uploadFielRequest.addHeader('upload-token', uploadToken);
        return uploadFielRequest.executeRequest();
    }).then((key)=>{
        const preview = {
            method: 'PIC_FILE',
            key: key
        };
        outerResolvePromise(preview);
    });
    return previewPromise;
}
function $0f0fbe645891c118$var$ideaPreviewCreate() {
    const preview = {
        method: 'IDEA'
    };
    return Promise.resolve(preview);
}

});

parcelRegister("49k2f", function(module, exports) {

$parcel$export(module.exports, "isValidBranch", () => $30578b4a4af8446b$export$dab8973d66473523);

var $lz1lC = parcelRequire("lz1lC");
const $30578b4a4af8446b$var$MAX_NAME_LENGTH = 100;
const $30578b4a4af8446b$var$MAX_DESCRIPTION_LENGTH = 65535;
const $30578b4a4af8446b$var$MAX_TAG_LENGTH = 50;
const $30578b4a4af8446b$var$previewIsValidDictionary = {
    'YT_URL': $30578b4a4af8446b$var$isValidYoutubePreview,
    'SCL_URL': $30578b4a4af8446b$var$isValidSoundCloudPreview,
    'PIC_FILE': $30578b4a4af8446b$var$isValidPicFilePreview,
    'IDEA': $30578b4a4af8446b$var$isValidIdeaPreview
};
function $30578b4a4af8446b$var$isValidPreview(previewObject) {
    if (!previewObject) return false;
    const method = previewObject.method;
    const isValidPreviewFunction = $30578b4a4af8446b$var$previewIsValidDictionary[method];
    if (!(isValidPreviewFunction instanceof Function)) return false;
    return isValidPreviewFunction(previewObject);
}
function $30578b4a4af8446b$var$isValidYoutubePreview(previewObject) {
    const method = previewObject.method;
    if (!method || method !== 'YT_URL') return false;
    const videoId = (0, $lz1lC.ParamValidator).basicSanitize(previewObject.videoId);
    if (!(0, $lz1lC.ParamValidator).isValidYoutubeVideoId(videoId)) return false;
    if (!/^[a-zA-Z0-9_-]{5,20}$/.test(videoId)) return false;
    previewObject.videoId = videoId;
    return true;
}
function $30578b4a4af8446b$var$isValidSoundCloudPreview(previewObject) {
    const method = previewObject.method;
    if (!method || method !== 'SCL_URL') return false;
    const trackId = (0, $lz1lC.ParamValidator).basicSanitize(previewObject.trackId);
    if (!(0, $lz1lC.ParamValidator).isValidSoundCloudTrackId(trackId)) return false;
    previewObject.trackId = trackId;
    return true;
}
function $30578b4a4af8446b$var$isValidPicFilePreview(previewObject) {
    const method = previewObject.method;
    if (!method || method !== 'PIC_FILE') return false;
    const storageLink = (0, $lz1lC.ParamValidator).basicSanitize(previewObject.key);
    if (!(0, $lz1lC.ParamValidator).isValidStorageFileLink(storageLink)) return false;
    previewObject.key = storageLink;
    return true;
}
function $30578b4a4af8446b$var$isValidIdeaPreview(previewObject) {
    const method = previewObject.method;
    if (!method || method !== 'IDEA') return false;
    const numberOfFields = Object.keys(previewObject).length;
    return numberOfFields === 1;
}
function $30578b4a4af8446b$var$isValidResourceLink(linkObj) {
    console.log("linkObj ", linkObj);
    if (!linkObj) return false;
    return (0, $lz1lC.ParamValidator).isValidLink(linkObj.link) && (0, $lz1lC.ParamValidator).isSafeTextNullable(linkObj.commentary, 500);
}
function $30578b4a4af8446b$export$dab8973d66473523(obj) {
    if (!obj) throw new Error("No update data provided");
    // Sanitize strings using ParamValidator
    const sanitized = {
        preview: obj.preview,
        name: (0, $lz1lC.ParamValidator).basicSanitize(obj.name),
        description: (0, $lz1lC.ParamValidator).basicSanitize(obj.description),
        resources: obj.resources?.map((l)=>({
                link: (0, $lz1lC.ParamValidator).normalizeLink((0, $lz1lC.ParamValidator).basicSanitize(l.link)),
                commentary: (0, $lz1lC.ParamValidator).basicSanitize(l.commentary)
            })) ?? null,
        tags: obj.tags?.map((tag)=>(0, $lz1lC.ParamValidator).basicSanitize(tag)) ?? null
    };
    // --- Validate fields ---
    if (!$30578b4a4af8446b$var$isValidPreview(sanitized.preview)) throw new (0, $lz1lC.ValidationError)("Something's wrong with your preview");
    if (sanitized.name && !(0, $lz1lC.ParamValidator).isValidText(sanitized.name, $30578b4a4af8446b$var$MAX_NAME_LENGTH)) throw new (0, $lz1lC.ValidationError)("Your branch name is either too long or contains inappropriate characters");
    if (sanitized.description && !(0, $lz1lC.ParamValidator).isSafeTextNullableExpanded(sanitized.description, $30578b4a4af8446b$var$MAX_DESCRIPTION_LENGTH)) throw new (0, $lz1lC.ValidationError)("Your branch description is either too long or contains inappropriate characters");
    if (sanitized.resources?.length) {
        console.log("sanitized.resources ", sanitized.resources);
        for (const resource of sanitized.resources){
            if (!$30578b4a4af8446b$var$isValidResourceLink(resource)) throw new (0, $lz1lC.ValidationError)(`Something about your link ${resource.link.substring(0, 5)}... makes it inappropriate`);
        }
    }
    if (sanitized.tags?.length) for (const tag of sanitized.tags){
        if (!(0, $lz1lC.ParamValidator).isValidText(tag, $30578b4a4af8446b$var$MAX_TAG_LENGTH)) throw new (0, $lz1lC.ValidationError)(`Your tag ${tag} is either too long or contains inappropriate characters`);
    }
    return sanitized;
}

});

parcelRegister("ha4AH", function(module, exports) {

$parcel$export(module.exports, "createPreviewTypeCircle", () => $c7e6ee810d533c60$export$a2538739d8526684);

var $iqZMU = parcelRequire("iqZMU");
function $c7e6ee810d533c60$export$a2538739d8526684(nodeWindowPlaque) {
    const existingPreviewTypeCircle = document.querySelector('.select-type-attention-circle');
    const selectSection = nodeWindowPlaque.querySelector('#select-type-section');
    if (!existingPreviewTypeCircle) {
        const selectSectionWidth = selectSection.offsetWidth;
        const selectSectionHeight = selectSection.offsetHeight;
        const rect = selectSection.getBoundingClientRect();
        const offsetLeft = rect.left + selectSectionWidth / 2;
        const offsetTop = rect.top + selectSectionHeight / 2;
        const previewTypeCircle = (0, $iqZMU.createElement)('img', null, [
            'select-type-attention-circle'
        ]);
        previewTypeCircle.src = '/images/attention/preview_type_circle.gif';
        previewTypeCircle.style.width = selectSectionWidth * 1.3 - selectSectionHeight / 2 + 'px';
        previewTypeCircle.style.left = offsetLeft + 'px';
        previewTypeCircle.style.top = offsetTop + 'px';
        const select = selectSection.querySelector('select');
        select.addEventListener('click', ()=>previewTypeCircle.remove());
        nodeWindowPlaque.append(previewTypeCircle);
    }
}

});


parcelRegister("2uBUx", function(module, exports) {

$parcel$export(module.exports, "wrapLinkInSafeRedirect", () => $1d0bca71ba5eafcc$export$3fc07481cc9b4a54);

var $7NPUP = parcelRequire("7NPUP");
const $1d0bca71ba5eafcc$var$baseRedirectUrl = (0, $7NPUP.SITE_URL) + '/redirect'; // Change this to your actual redirect path
function $1d0bca71ba5eafcc$export$3fc07481cc9b4a54(originalUrl) {
    const encodedUrl = encodeURIComponent(originalUrl);
    return `${$1d0bca71ba5eafcc$var$baseRedirectUrl}?url=${encodedUrl}`;
}

});

parcelRegister("1vUzf", function(module, exports) {

$parcel$export(module.exports, "abbreviateNumber", () => $11a490d1ec2e811b$export$36d5e0d2b514f546);
function $11a490d1ec2e811b$export$36d5e0d2b514f546(number) {
    if (number < 1000) return `${number}`;
    if (number < 10000) return `${Math.round(number / 1000 * 100) / 100}k`;
    if (number < 100000) return `${Math.round(number / 1000 * 10) / 10}k`;
    if (number < 1000000) return `${Math.round(number / 1000)}k`;
    if (number < 10000000) return `${Math.round(number / 1000000 * 100) / 100}M`;
    if (number < 100000000) return `${Math.round(number / 1000000 * 10) / 10}M`;
    if (number < 1000000000) return `${Math.round(number / 1000000)}M`;
}

});


//# sourceMappingURL=base_feed.7169a3a4.js.map
